/*
 * Apex Theme — Core JavaScript
 * AMZ Development — https://ammzish.com
 * Built for Apex Theme
 */

window.apx = window.apx || {};
window.Shopify = window.Shopify || {};

apx.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (apx.config.isTouch) {
  document.documentElement.className += ' amz-has-touch';
}



apx.recentlyViewed = {
  recent: {},
  recentOrder: [],
  productInfo: {}
};

(function(){
  'use strict';

  apx.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = apx.delegate.on;
  window.off = Element.prototype.off = apx.delegate.off;
  
  apx.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  apx.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      if (!document.documentElement.classList.contains('js-drawer-open') && !document.querySelector('.drawer--is-open')) {
      document.documentElement.classList.remove('lock-scroll');
    }
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  const trapFocusHandlers = {};
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When apx.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */
  
  apx.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = apx && apx.settings && apx.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = apx.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = apx.utils.defaultTo(precision, 2);
        thousands = apx.utils.defaultTo(thousands, ',');
        decimal = apx.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  apx.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function buildImagePath(string, widths) {
  
      if (string == null) return [];
  
      if (widths) {
        const imageUrls = [];
  
        widths.forEach(width => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`
          } else {
            url += ` ${width}w,`
          }
          imageUrls.push(url);
        })
        return imageUrls;
      } else {
        return [string];
      }
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath
    };
  })();
  
  // Init section function when it's visible, then disable observer
  apx.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
  
    observer.observe(options.element)
  }
  
  apx.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  apx.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      apx.utils.wrap(table, wrapWith);
    });
  
    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      apx.utils.wrap(iframe, wrapWith);
    }
  
    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  apx.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  apx.Sections.prototype = Object.assign({}, apx.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-apx-section');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (apx.refreshAOS) { apx.refreshAOS(true) }
      if (apx && apx.initGlobals) {
        apx.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-apx-section="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-apx-section="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  apx.Variants = (function() {
  
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();
  
      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }
  
    Variants.prototype = Object.assign({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var result = [];
  
        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        result = apx.utils.compact(result);
  
        return result;
      },
  
      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function(key) {
        return parseInt(key.substr(-1));
      },
  
      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function(variant) {
        return this._getCurrentOptions().reduce((count, {value, index}) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        },0)
      },
  
      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({value, index}) => {
            return variant[index] === value;
          });
  
          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },
  
      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function(lastSelectedOption) {
        if (!lastSelectedOption) return null;
  
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({value, index}) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({value, index}) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });
  
        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;
  
          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);
  
          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },
  
      _getVariantFromOptions: function(lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);
  
        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }
  
      },
  
      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;
  
          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value
            if (input.checked) {
              input.dispatchEvent(new Event('updateSwatch'));
            }
          } else {
            input.value = variant[index];
          }
        }
      },
  
      _onSelectChange: function({srcElement}) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
  
        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });
  
        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))
  
        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();
  
        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index
        }
  
        this.container.dispatchEvent(new CustomEvent('variantChange', {detail}));
        document.dispatchEvent(new CustomEvent('variant:change', {detail}));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant) {
        if (!variant.featured_image) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updatePrice: function(variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateUnitPrice: function(variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateSKU: function(variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;
  
        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  
    return Variants;
  })();
  
  window.vimeoApiReady = function () {
    apx.config.vimeoLoading = true
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        apx.config.vimeoReady = true
        apx.config.vimeoLoading = false
        document.dispatchEvent(new CustomEvent('vimeoReady'))
      })
  }
  
  function checkIfVimeoIsReady () {
    let wait
    let timeout
  
    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return
        }
  
        clearInterval(wait)
        clearTimeout(timeout)
        resolve()
      }, 500)
  
      timeout = setTimeout(function () {
        clearInterval(wait)
        reject()
      }, 4000) // subjective. test up to 8 times over 4 seconds
    })
  }
  
  apx.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    }
  
    function VimeoPlayer (divId, videoId, options) {
      this.divId = divId
      this.el = document.getElementById(divId)
      this.videoId = videoId
      this.iframe = null
      this.options = options
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent)
      }
  
      this.setAsLoading()
  
      if (apx.config.vimeoReady) {
        this.init()
      } else {
        apx.LibraryLoader.load('vimeo', window.vimeoApiReady)
        document.addEventListener('vimeoReady', this.init.bind(this))
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults
        args.id = this.videoId
  
        this.videoPlayer = new Vimeo.Player(this.el, args)
  
        this.videoPlayer.ready().then(this.playerReady.bind(this))
      },
  
      playerReady: function () {
        this.iframe = this.el.querySelector('iframe')
        this.iframe.setAttribute('tabindex', '-1')
  
        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false)
        }
  
        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1)
        } else {
          this.videoPlayer.setVolume(0)
        }
  
        this.setAsLoaded()
  
        // pause when out of view
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play()
            } else {
              this.pause()
            }
          })
        }, { rootMargin: '0px 0px 50px 0px' })
  
        observer.observe(this.iframe)
      },
  
      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },
  
      setAsLoaded: function () {
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (apx.refreshAOS) { apx.refreshAOS(true) }
        }
      },
  
      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },
  
      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play()
        }
      },
  
      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause()
        }
      },
  
      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy()
        }
      }
    })
  
    return VimeoPlayer
  })()
  
  window.onYouTubeIframeAPIReady = function() {
    apx.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  apx.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in apx.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (apx.config.youTubeReady) {
        this.init();
      } else {
        apx.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (apx.refreshAOS) { apx.refreshAOS(true) }
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  (function(){})();

/**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */
  
  apx.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }
  
    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams)
  
        const sectionRenders = this.sections.map(section => {
  
          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;
  
          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });
  
        if (updateURLHash) this.updateURLHash(updatedParams);
  
        return Promise.all(sectionRenders);
      },
  
      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);
  
        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },
  
      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
  
        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },
  
      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );
  
        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }
  
            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }
  
        return section;
      },
  
      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
  
        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          };
        }
  
        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }
  
        return clone;
      },
  
      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`,
        );
      },
  
      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });
  
    return AjaxRenderer;
  })();
  // Theme editor beacon removed. Keep runtime flow intact without external calls.
  apx.cart = {
    getCart: function() {
      var url = ''.concat(apx.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      var url = ''.concat(apx.routes.cartPage, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(response => response.text())
      .catch(e => console.error(e));
    },
  
    changeItem: function(key, qty) {
  
      return this._updateCart({
        url: ''.concat(apx.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },
  
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => { return response.text() })
      .then(cart => { return cart; });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: (apx.routes && apx.routes.cartUpdate) || '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: apx.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: (apx.routes && apx.routes.cartUpdate) || '/cart/update.js',
        data: JSON.stringify({
          note: apx.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }
  
  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  apx.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
  
      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };
  
    var config = {
      requiresTerms: false
    };
  
    function CartForm(form) {
      if (!form) {
        return;
      }
  
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);
  
      this.cartItemsUpdated = false;
  
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }
  
      this.init();
    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
  
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
  
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
  
        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            apx.cart.updateNote(newNote);
          });
        }
  
        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.apxBuildCart();
        }.bind(this));
      },
  
      reInit: function() {
        this.initQtySelectors();
      },
  
      onSubmit: function(evt) {
        this.submitBtn.classList.add(classes.btnLoading);
  
        /*
          Checks for drawer or cart open class on body element
          and then stops the form from being submitted. We are also
          checking against a custom property, this.cartItemsUpdated = false.
  
          Error is handled in the quantityChanged method
  
          For Expanse/Fetch/Gem quick add, if an error is present it is alerted
          through the add to cart fetch request in quick-add.js.
  
          Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
          Expanse/Fetch/Gem when using quick add
        */
  
        if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
          document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
          this.submitBtn.classList.remove(classes.btnLoading);
          evt.preventDefault();
          return false;
        }
  
        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(apx.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(text) {
        const html = document.createElement('div');
        html.innerHTML = text;
  
        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts')
        }
      },
  
      apxBuildCart: function() {
        apx.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },
  
      cartMarkup: function(text) {
        var markup = this._parseProductHTML(text);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;
  
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }
  
        this.updateCount(count);
  
        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);
  
        // Update subtotal
        this.subtotal.innerHTML = apx.Currency.formatMoney(subtotal, apx.settings.moneyFormat);
  
        this.reInit();
  
        if (apx.refreshAOS) { apx.refreshAOS(true) }
  
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },
  
      updateCartDiscounts: function(markup) {
        if (!this.discounts) {
          return;
        }
        // When there are no discounts, `markup` can be null.
        // `Element.append(null)` inserts the literal text "null".
        // Keep the discounts area empty + hidden in that case.
        if (!markup) {
          this.discounts.innerHTML = '';
          this.discounts.classList.add('hide');
          return;
        }

        this.discounts.classList.remove('hide');
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new apx.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },
  
      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];
  
        if (!key || !qty) {
          return;
        }
  
        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }
  
        apx.cart.changeItem(key, qty)
          .then(function(cart) {
  
            const parsedCart = JSON.parse(cart);
  
            if (parsedCart.status === 422) {
              alert(parsedCart.message);
            } else {
              const updatedItem = parsedCart.items.find(item => item.key === key);
  
              // Update cartItemsUpdated property on object so we can reference later
              if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                this.cartItemsUpdated = true;
              }
  
              if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                if (updatedItem.quantity !== qty) {
                }
                // Reset property on object so that checkout button will work as usual
                this.cartItemsUpdated = false;
              }
  
              if (parsedCart.item_count > 0) {
                this.wrapper.classList.remove('is-empty');
              } else {
                this.wrapper.classList.add('is-empty');
              }
            }
  
            this.apxBuildCart();
  
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: parsedCart
              }
            }));
          }.bind(this))
          .catch(function(XMLHttpRequest){});
      },
  
      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = apx.Currency.formatMoney(subtotal, apx.settings.moneyFormat);
      },
  
      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }
  
        if (savings > 0) {
          var amount = apx.Currency.formatMoney(savings, apx.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = apx.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },
  
      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }
  
        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });
  
    return CartForm;
  })();
  
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  apx.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;
  
        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }
  
        var totalHeight = isOpen
                        ? parentCollapsibleEl.offsetHeight - childHeight
                        : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      apx.utils.prepareTransition(container, function() {
  
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  apx.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();
  
        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },
  
      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },
  
      _connectOptions: function(event) {
        event.preventDefault();
  
        this._submitForm(event.currentTarget.dataset.value);
      },
  
      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;
  
        if (disclosureLostFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);
  
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureKeyUp: function(event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },
  
      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !isOption) {
          this._hideList();
        }
      },
  
      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },
  
      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },
  
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },
  
      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });
  
    return Disclosure;
  })();
  
  apx.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
  
      if (!this.drawer) {
        return;
      }

      this.drawer.setAttribute('data-amz-animation-style', apx.animationValue ? apx.animationValue('drawerStyle', 'slide_fade') : 'slide_fade');
      this.drawer.setAttribute('data-amz-content-style', apx.animationValue ? apx.animationValue('drawerContentStyle', 'rise_fade') : 'rise_fade');
      if (apx.animationValue && apx.animationValue('drawerContentEnable', true) === false) {
        this.drawer.setAttribute('data-amz-content-style', 'none');
      }
  
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });
  
        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
  
        this.drawer.classList.remove('drawer--is-closing', 'drawer--is-opening');
        this.drawer.classList.add('drawer--is-preparing');
        document.documentElement.classList.add(this.config.openClass);

        apx.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove('drawer--is-preparing');
          this.drawer.classList.add(this.config.activeDrawer, 'drawer--is-opening');
        }.bind(this));
  
        window.setTimeout(function() {
          if (this.isOpen) this.drawer.classList.remove('drawer--is-opening');
        }.bind(this), apx.drawerAnimationTime ? apx.drawerAnimationTime('open') : 520);

        this.isOpen = true;
  
        apx.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
  
        this.bindEvents();
      },
  
      close: function(evt) {
        if (!this.isOpen) {
          return;
        }
  
        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }
  
        // deselect any focused form elements
        document.activeElement.blur();
  
        this.drawer.classList.remove('drawer--is-opening');
        this.drawer.classList.add('drawer--is-closing');

        apx.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);

        var closeDelay = apx.drawerAnimationTime ? apx.drawerAnimationTime('close') : 410;
        window.setTimeout(function() {
          this.drawer.classList.remove('drawer--is-closing');
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), closeDelay);
  
        this.isOpen = false;
  
        apx.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        apx.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        apx.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });
  
    return Drawers;
  })();
  
  apx.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
      this.modal.apxModal = this;
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget;
        this.activeSource.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(...this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        apx.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      }, 100);
  
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      apx.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  /*============================================================================
    ParallaxImage
  ==============================================================================*/
  
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = null;
      this.raf = null;
      this.resizeTimer = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      };
      this.directionMultipliers = {
        0: [1, 0],
        90: [0, -1],
        180: [-1, 0],
        270: [0, 1]
      };
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.parallaxImage = this.querySelector('[data-amz-plx-img]');
      if (!this.parallaxImage) return;
      this.update();
      this.requestUpdate();
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('orientationchange', this.handleResize);
      this.resizeTimer = setTimeout(() => this.requestUpdate(), 300);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('orientationchange', this.handleResize);
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
    }

    handleScroll() {
      this.requestUpdate();
    }

    handleResize() {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.requestUpdate(), 80);
    }

    requestUpdate() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.update();
      });
    }

    normalizeAngle(angle) {
      angle = this.directionMap[angle] ?? parseFloat(angle);
      if (angle !== angle) angle = 90;
      angle %= 360;
      if (angle < 0) angle += 360;
      return angle;
    }

    getMultipliers(angle) {
      if (angle % 90) {
        const radians = angle * Math.PI / 180;
        return [Math.cos(radians), Math.sin(radians) * -1];
      }
      return this.directionMultipliers[angle] || this.directionMultipliers[90];
    }

    getMovementPixels(movement, width, height, multipliers) {
      const parsed = parseFloat(movement);
      if (parsed !== parsed) return 100;
      if (String(movement).indexOf('px') > -1) return parsed;
      const baseSize = Math.abs(multipliers[1]) >= Math.abs(multipliers[0]) ? height : width;
      return Math.ceil(baseSize * (parsed / 100));
    }

    update() {
      const element = this.parallaxImage;
      if (!element) return;
      if (element.dataset.mobile === 'false' && window.innerWidth < 769) {
        element.style.transform = '';
        return;
      }

      const containerRect = this.getBoundingClientRect();
      if (!containerRect.height || !containerRect.width) return;

      const angle = this.normalizeAngle(element.dataset.angle);
      const multipliers = this.getMultipliers(angle);
      const movementPixels = this.getMovementPixels(element.dataset.movement, containerRect.width, containerRect.height, multipliers);
      const expandX = movementPixels * Math.abs(multipliers[0]);
      const expandY = movementPixels * Math.abs(multipliers[1]);

      element.style.width = expandX ? `calc(var(--amz-plx-img-width, 100%) + ${expandX}px)` : 'var(--amz-plx-img-width, 100%)';
      element.style.height = expandY ? `calc(var(--amz-plx-img-height, 100%) + ${expandY}px)` : 'var(--amz-plx-img-height, 100%)';

      const scrollArea = window.innerHeight + containerRect.height;
      const progress = (window.innerHeight - containerRect.top) / scrollArea;
      const clamped = Math.min(Math.max(progress, 0), 1);
      const position = clamped * movementPixels;

      element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
    }
  }
  
  customElements.define('amz-plx-img', ParallaxImage);
  
  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('apx.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }
  
  apx.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };
  
    function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};
  
      return this.init();
    }
  
    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }
  
        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
  
        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
  
        return this.createPriceRange();
      },
  
      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }
  
        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });
  
        slider.on('update', values => {
          this.displayMinEl.innerHTML = apx.Currency.formatMoney(
            values[0],
            apx.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = apx.Currency.formatMoney(
            values[1],
            apx.settings.moneyFormat,
          );
  
          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });
  
        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];
  
          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });
  
        return slider;
      },
    });
  
    return PriceRange;
  })();
  
  apx.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;
  
      var submitSelector = submit ? submit : '.add-to-cart';
  
      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();
  
        if (status.loading) {
          return;
        }
  
        if (this.addToCart) {
          this.addToCart.classList.add('btn--loading');
        }
  
        status.loading = true;
  
        var data = apx.utils.serialize(this.form);
        var resetLoading = function() {
          status.loading = false;
          if (this.addToCart) {
            this.addToCart.classList.remove('btn--loading');
          }
        }.bind(this);
  
        fetch(apx.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          resetLoading();

          if (data.status === 422) {
            this.error(data);
            return;
          }

          this.success(data);
  
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this))
        .catch(function(error) {
          resetLoading();
          console.error('Add to cart failed', error);
          this.error({description: apx.strings.cartError || 'Something went wrong. Please try again.'});
        }.bind(this));
      },
  
      success: function(product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        if (apx.settings.cartType === 'page') {
          window.location = apx.routes.cartPage;
        }
  
        this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          },
          bubbles: true
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },
  
      error: function(error) {
        if (!error.description) {
          console.warn(error);
          return;
        }
  
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
  
        if (typeof error.description === 'object') {
          errorDiv.textContent = error.message;
        } else {
          errorDiv.textContent = error.description;
        }
  
        this.form.append(errorDiv);
  
        this.form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          },
          bubbles: true
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });
  
    return ProductForm;
  })();
  
  apx.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-amz-prod-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;
  
        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };
  
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      apx.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
  
          var modelJson = document.querySelector('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
  
      model.container.addEventListener('mediaVisible', function(event) {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (apx.config.isTouch) return;
        if (!event.detail.autoplayMedia) return;
        model.modelViewerUi.play();
      });
  
      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });
  
      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  
  apx.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
  
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty + 1);
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty());
        }.bind(this));
      },
  
      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
  
        this.input.value = qty;
  
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });
  
    return QtySelector;
  })();
  
  apx.initQuickShop = function() {
    var products = document.querySelectorAll('.amz-gp');

    if (!products.length || !apx.settings.quickView) {
      return;
    }

    function preloadCard(card, btn) {
      if (!card || !card.dataset.productId || !card.dataset.productHandle) return null;
      return apx.preloadProductModal(card.dataset.productHandle, card.dataset.productId, btn || card.querySelector('[data-amz-quick-view-trigger], .quick-product__btn'));
    }

    products.forEach(function(product) {
      if (product.dataset.amzQuickViewHoverReady === 'true') return;
      product.dataset.amzQuickViewHoverReady = 'true';
      var trigger = function(evt) {
        preloadCard(product, evt && evt.target ? evt.target.closest('[data-amz-quick-view-trigger], .quick-product__btn') : null);
      };
      product.addEventListener('mouseover', trigger, { passive: true });
      product.addEventListener('focusin', trigger, { passive: true });
    });

    if (!apx.quickViewClickDelegationReady) {
      apx.quickViewClickDelegationReady = true;
      document.addEventListener('click', function(evt) {
        var btn = evt.target && evt.target.closest ? evt.target.closest('[data-amz-quick-view-trigger], .quick-product__btn') : null;
        if (!btn || btn.closest('.modal--quick-shop')) return;
        var card = btn.closest('.amz-gp');
        if (!card || !card.dataset.productId || !card.dataset.productHandle) return;
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
        apx.openQuickViewFromGrid(card, btn);
      }, true);
    }

    function preloadVisibleCards(limit) {
      var count = 0;
      products.forEach(function(product) {
        if (count >= limit) return;
        var rect = product.getBoundingClientRect();
        var nearViewport = rect.top < window.innerHeight * 2.2 && rect.bottom > -window.innerHeight * 0.6;
        if (!nearViewport) return;
        count += 1;
        preloadCard(product, product.querySelector('[data-amz-quick-view-trigger], .quick-product__btn'));
      });
    }

    var canPreloadVisible = !(window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);
    if (canPreloadVisible) {
      window.requestAnimationFrame(function() { preloadVisibleCards(12); });
      window.setTimeout(function() { preloadVisibleCards(16); }, 180);
      window.setTimeout(function() { preloadVisibleCards(24); }, 900);
    }
  };

  apx.setQuickViewTriggerState = function(productId, className, active) {
    document.querySelectorAll('.js-modal-open-quick-modal-' + productId + ', [data-product-id="' + productId + '"][data-amz-quick-view-trigger]').forEach(function(btn) {
      btn.classList.toggle(className, !!active);
      if (className === 'is-active') {
        btn.setAttribute('aria-expanded', active ? 'true' : 'false');
      }
    });
  };

  apx.openQuickViewFromGrid = function(card, btn) {
    var productId = card.dataset.productId;
    var handle = card.dataset.productHandle;
    if (!productId || !handle) return;
    if (apx.quickViewOpening) return;
    apx.quickViewOpening = productId;
    var modalId = 'QuickShopModal-' + productId;
    document.querySelectorAll('.modal--quick-shop.modal--is-active').forEach(function(item) {
      if (item.id === modalId) return;
      if (item.apxModal && typeof item.apxModal.close === 'function' && item.apxModal.modalIsOpen) {
        item.apxModal.close();
      } else {
        item.classList.remove('modal--is-active', 'modal--is-closing');
        item.style.removeProperty('display');
        item.setAttribute('aria-hidden', 'true');
      }
    });
    document.querySelectorAll('.amz-qv-card-active').forEach(function(item) {
      if (item !== card) item.classList.remove('amz-qv-card-active');
    });
    card.classList.add('amz-qv-card-active');
    apx.setQuickViewTriggerState(productId, 'is-loading', true);
    apx.preloadProductModal(handle, productId, btn).then(function(instance) {
      apx.setQuickViewTriggerState(productId, 'is-loading', false);
      apx.setQuickViewTriggerState(productId, 'is-active', true);
      var modal = document.getElementById(modalId);
      if (modal) {
        modal.style.setProperty('display', 'flex', 'important');
        modal.setAttribute('aria-hidden', 'false');
      }
      var modalInstance = instance || modal && modal.apxModal;
      if (modalInstance && typeof modalInstance.open === 'function') {
        modalInstance.open();
      } else if (modal) {
        modal.classList.add('modal--is-active');
        document.documentElement.classList.add('modal-open');
      }
      if (modal && apx.quickViewEnhancements) {
        apx.quickViewEnhancements(modal);
      }
      if (window.AMZStockProgress && modal) {
        try { window.AMZStockProgress.initAll(modal); } catch (err) {}
      }
      if (modal) {
        try { document.dispatchEvent(new CustomEvent('apx:quick-view:opened', { detail: { root: modal, modal: modal } })); } catch (err) {}
      }
      if (modal && apx.lockQuickViewScroll) {
        apx.lockQuickViewScroll(modal);
      }
      apx.quickViewOpening = null;
    }).catch(function() {
      card.classList.remove('amz-qv-card-active');
      apx.quickViewOpening = null;
      apx.setQuickViewTriggerState(productId, 'is-loading', false);
      apx.setQuickViewTriggerState(productId, 'is-active', false);
    });
  };

  apx.preloadProductModal = function(handle, productId, btn) {
    apx.quickViewPreloadPromises = apx.quickViewPreloadPromises || {};
    var modalId = 'QuickShopModal-' + productId;
    var modal = document.getElementById(modalId);
    var holder = document.getElementById('QuickShopHolder-' + handle);

    if (modal && modal.querySelector('.product-section')) {
      if (!modal.apxModal) {
        modal.apxModal = new apx.Modals(modalId, 'quick-modal-' + productId);
      }
      if (btn) btn.classList.remove('quick-product__btn--not-ready');
      return Promise.resolve(modal.apxModal);
    }

    if (apx.quickViewPreloadPromises[productId]) {
      return apx.quickViewPreloadPromises[productId];
    }

    var url = apx.routes.home + '/products/' + handle;
    url = url.replace(/\/+/g, '/');

    apx.quickViewPreloadPromises[productId] = fetch(url, { credentials: 'same-origin' })
    .then(function(response) {
      return response.text();
    })
    .then(function(text) {
      var html = document.createElement('div');
      html.innerHTML = text;
      var div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');
      modal = document.getElementById(modalId);
      holder = document.getElementById('QuickShopHolder-' + handle);

      if (!holder || !div || !modal) {
        throw new Error('Quick View product section was not found');
      }

      div.dataset.modal = 'true';
      div.removeAttribute('data-history');
      div.classList.add('is-modal');
      holder.innerHTML = '';
      holder.append(div);

      var instance = modal.apxModal || new apx.Modals(modalId, 'quick-modal-' + productId);
      modal.apxModal = instance;

      apx.sections.register('product', apx.Product, holder);
      apx.collapsibles.init();
      apx.videoModal();

      if (window.AMZStockProgress) {
        try { window.AMZStockProgress.initAll(holder); } catch (err) {}
      }
      try { document.dispatchEvent(new CustomEvent('apx:quick-view:loaded', { detail: { root: holder, modal: modal, section: div } })); } catch (err) {}

      if (apx.quickViewEnhancements) {
        apx.quickViewEnhancements(holder);
      }

      document.querySelectorAll('.js-modal-open-quick-modal-' + productId).forEach(function(trigger) {
        trigger.classList.remove('quick-product__btn--not-ready');
        trigger.setAttribute('aria-expanded', 'false');
      });

      if (modal.dataset.amzQvCloseReady !== 'true') {
        modal.dataset.amzQvCloseReady = 'true';
        document.addEventListener('modalClose.' + modalId, function() {
          modal.style.removeProperty('display');
          modal.setAttribute('aria-hidden', 'true');
          document.querySelectorAll('.amz-qv-card-active[data-product-id="' + productId + '"]').forEach(function(item) {
            item.classList.remove('amz-qv-card-active');
          });
          if (apx.unlockQuickViewScroll) {
            apx.unlockQuickViewScroll(modal);
            window.requestAnimationFrame(function() { apx.unlockQuickViewScroll(modal); });
            window.setTimeout(function() { apx.unlockQuickViewScroll(modal); }, 520);
          }
          apx.quickViewOpening = null;
          apx.setQuickViewTriggerState(productId, 'is-active', false);
          apx.setQuickViewTriggerState(productId, 'is-loading', false);
        });
      }

      return instance;
    })
    .catch(function(error) {
      delete apx.quickViewPreloadPromises[productId];
      throw error;
    });

    return apx.quickViewPreloadPromises[productId];
  }

  apx.lockQuickViewScroll = function(modal) {
    if (!modal) return;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (modal.dataset.amzQvBodyLocked !== 'true') {
      modal.dataset.amzQvBodyLocked = 'true';
      modal.dataset.amzQvScrollY = String(scrollY);
    }
    document.documentElement.classList.add('amz-qv-scroll-lock');
    document.body.classList.add('amz-qv-scroll-lock');
    document.documentElement.style.setProperty('overflow', 'hidden');
    document.documentElement.style.setProperty('overscroll-behavior', 'none');
    document.body.style.setProperty('overflow', 'hidden');
    document.body.style.setProperty('overscroll-behavior', 'none');
  };

  apx.unlockQuickViewScroll = function(modal) {
    var activeModal = modal || document.querySelector('.modal--quick-shop[data-amz-qv-body-locked="true"]');
    var scrollY = null;
    if (activeModal && activeModal.dataset.amzQvScrollY) {
      scrollY = parseInt(activeModal.dataset.amzQvScrollY || '0', 10);
    }
    document.querySelectorAll('.modal--quick-shop[data-amz-qv-body-locked]').forEach(function(item) {
      item.dataset.amzQvBodyLocked = 'false';
      item.removeAttribute('data-amz-qv-scroll-y');
    });
    if (document.querySelector('.modal--quick-shop.modal--is-active')) return;
    document.documentElement.classList.remove('amz-qv-scroll-lock');
    document.body.classList.remove('amz-qv-scroll-lock');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('height');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overscroll-behavior');
    document.body.style.removeProperty('touch-action');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overscroll-behavior');
    document.documentElement.style.removeProperty('touch-action');
    document.documentElement.classList.remove('lock-scroll');
    if (Number.isFinite(scrollY)) {
      window.scrollTo(0, scrollY);
      window.requestAnimationFrame(function() {
        window.scrollTo(0, scrollY);
        document.body.style.webkitTransform = 'translateZ(0)';
        document.body.offsetHeight;
        document.body.style.removeProperty('-webkit-transform');
      });
    }
  };

  apx.bindQuickViewScrollGuard = function(modal) {
    if (!modal || modal.dataset.amzQvScrollGuardReady === 'true') return;
    modal.dataset.amzQvScrollGuardReady = 'true';
    var lastTouchY = 0;

    function getScroller(target) {
      if (!target || !target.closest) return null;
      return target.closest('.modal__centered-content');
    }

    function preventOutside(event) {
      if (!modal.classList.contains('modal--is-active')) return;
      var scroller = getScroller(event.target);
      if (!scroller) {
        if (event.cancelable) event.preventDefault();
        return;
      }
      if (event.type === 'wheel') {
        var maxWheel = scroller.scrollHeight - scroller.clientHeight;
        if (maxWheel <= 1) {
          if (event.cancelable) event.preventDefault();
          return;
        }
        var goingDown = event.deltaY > 0;
        var goingUp = event.deltaY < 0;
        if (goingUp && scroller.scrollTop <= 0) {
          if (event.cancelable) event.preventDefault();
        }
        if (goingDown && scroller.scrollTop >= maxWheel - 1) {
          if (event.cancelable) event.preventDefault();
        }
      }
    }

    modal.addEventListener('touchstart', function(event) {
      if (!modal.classList.contains('modal--is-active')) return;
      if (event.touches && event.touches.length) {
        lastTouchY = event.touches[0].clientY;
      }
    }, { passive: true });

    modal.addEventListener('touchmove', function(event) {
      if (!modal.classList.contains('modal--is-active')) return;
      var scroller = getScroller(event.target);
      if (!scroller) {
        if (event.cancelable) event.preventDefault();
        return;
      }
      if (!event.touches || !event.touches.length) return;
      var currentY = event.touches[0].clientY;
      var deltaY = currentY - lastTouchY;
      var max = scroller.scrollHeight - scroller.clientHeight;
      if (max <= 1) {
        if (event.cancelable) event.preventDefault();
      } else if (deltaY > 0 && scroller.scrollTop <= 0) {
        if (event.cancelable) event.preventDefault();
      } else if (deltaY < 0 && scroller.scrollTop >= max - 1) {
        if (event.cancelable) event.preventDefault();
      }
      lastTouchY = currentY;
    }, { passive: false });

    modal.addEventListener('wheel', preventOutside, { passive: false });
  };

  apx.quickViewEnhancements = function(root) {
    var scope = root || document;
    var modal = null;
    if (scope.matches && scope.matches('.modal--quick-shop')) {
      modal = scope;
    } else if (scope.closest) {
      modal = scope.closest('.modal--quick-shop');
    }
    if (!modal && scope.querySelector) {
      modal = scope.querySelector('.modal--quick-shop');
    }
    if (!modal) {
      modal = document.querySelector('.modal--quick-shop.modal--is-active');
    }
    if (!modal) return;
    if (apx.bindQuickViewScrollGuard) {
      apx.bindQuickViewScrollGuard(modal);
    }
    if (modal.classList.contains('modal--is-active') && apx.lockQuickViewScroll) {
      apx.lockQuickViewScroll(modal);
    }

    function toArray(list) {
      return Array.prototype.slice.call(list || []);
    }

    function getSlides(section) {
      return toArray(section.querySelectorAll('[data-product-photos] .product-main-slide'));
    }

    function getThumbLinks(section) {
      return toArray(section.querySelectorAll('[data-product-thumb], [data-amz-mobile-product-thumb]'));
    }

    function normalizeIndex(index, slides) {
      var value = parseInt(index, 10);
      if (!Number.isFinite(value)) value = 0;
      if (value < 0) value = 0;
      if (slides && slides.length && value >= slides.length) value = slides.length - 1;
      return value;
    }

    function activateThumbs(section, index, mediaId) {
      getThumbLinks(section).forEach(function(link) {
        var linkIndex = normalizeIndex(link.dataset.index, null);
        var sameIndex = linkIndex === index;
        var sameMedia = mediaId && String(link.dataset.id) === String(mediaId);
        var active = sameIndex || sameMedia;
        link.classList.toggle('is-active', active);
        link.setAttribute('aria-current', active ? 'true' : 'false');
        var item = link.closest('.product__thumb-item');
        if (item) item.classList.toggle('is-active', active);
      });
    }

    function syncThumbScroller(section, index, mediaId) {
      var link = null;
      if (mediaId) link = section.querySelector('[data-product-thumb][data-id="' + mediaId + '"], [data-amz-mobile-product-thumb][data-id="' + mediaId + '"]');
      if (!link) link = section.querySelector('[data-product-thumb][data-index="' + index + '"], [data-amz-mobile-product-thumb][data-index="' + index + '"]');
      if (!link) return;
      var item = link.closest('.product__thumb-item') || link;
      var scroller = item.closest('.product__thumbs--scroller, .amz-mobile-product-thumbs__scroller');
      if (!scroller) return;
      var thumbs = scroller.closest('[data-product-thumbs]');
      var vertical = thumbs ? thumbs.getAttribute('data-position') === 'beside' : false;
      if (vertical) {
        scroller.scrollTop = Math.max(0, item.offsetTop - 18);
      } else {
        scroller.scrollLeft = Math.max(0, item.offsetLeft - 18);
      }
    }

    function getGalleryParts(main) {
      var view = main ? main.querySelector('.amz-fc-view') : null;
      var track = main ? main.querySelector('.amz-fc-track') : null;
      return {
        view: view || main,
        track: track || main
      };
    }

    function setImportantStyle(element, property, value) {
      if (!element || !element.style) return;
      element.style.setProperty(property, value, 'important');
    }

    function clearImportantStyle(element, property) {
      if (!element || !element.style) return;
      element.style.removeProperty(property);
    }

    function forceManualGalleryShell(main) {
      if (!main) return;
      main.classList.add('amz-qv-smooth-gallery');
      var parts = getGalleryParts(main);
      setImportantStyle(main, 'overflow', 'hidden');
      setImportantStyle(main, 'width', '100%');
      setImportantStyle(main, 'max-width', '100%');
      if (parts.view) {
        setImportantStyle(parts.view, 'display', parts.view === parts.track ? 'flex' : 'block');
        setImportantStyle(parts.view, 'overflow-x', 'auto');
        setImportantStyle(parts.view, 'overflow-y', 'hidden');
        setImportantStyle(parts.view, 'scroll-snap-type', 'x mandatory');
        setImportantStyle(parts.view, '-webkit-overflow-scrolling', 'touch');
        setImportantStyle(parts.view, 'scroll-behavior', 'smooth');
        setImportantStyle(parts.view, 'width', '100%');
        setImportantStyle(parts.view, 'max-width', '100%');
      }
      if (parts.track && parts.track !== parts.view) {
        setImportantStyle(parts.track, 'display', 'flex');
        setImportantStyle(parts.track, 'flex-wrap', 'nowrap');
        setImportantStyle(parts.track, 'transform', 'none');
        setImportantStyle(parts.track, 'transition', 'none');
        setImportantStyle(parts.track, 'width', '100%');
        setImportantStyle(parts.track, 'max-width', '100%');
      }
      if (parts.track && parts.track === parts.view) {
        setImportantStyle(parts.track, 'display', 'flex');
        setImportantStyle(parts.track, 'flex-wrap', 'nowrap');
        setImportantStyle(parts.track, 'transform', 'none');
        setImportantStyle(parts.track, 'transition', 'none');
      }
    }

    function forceSlideState(slide, active) {
      if (!slide) return;
      setImportantStyle(slide, 'display', 'block');
      setImportantStyle(slide, 'flex', '0 0 100%');
      setImportantStyle(slide, 'max-width', '100%');
      setImportantStyle(slide, 'min-width', '100%');
      setImportantStyle(slide, 'opacity', '1');
      setImportantStyle(slide, 'position', 'relative');
      setImportantStyle(slide, 'scroll-snap-align', 'start');
      setImportantStyle(slide, 'transform', 'none');
      setImportantStyle(slide, 'visibility', 'visible');
      setImportantStyle(slide, 'width', '100%');
      setImportantStyle(slide, 'pointer-events', active ? 'auto' : 'none');
    }

    function scrollToQuickViewSlide(main, slide, smooth) {
      if (!main || !slide) return;
      var parts = getGalleryParts(main);
      if (!parts.view) return;
      var viewRect = parts.view.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      var left = Math.max(0, slideRect.left - viewRect.left + parts.view.scrollLeft);
      try {
        parts.view.scrollTo({ left: left, top: 0, behavior: smooth ? 'smooth' : 'auto' });
      } catch (err) {
        parts.view.scrollLeft = left;
      }
    }

    function detectQuickViewSlideIndex(section) {
      var main = section.querySelector('[data-product-photos]');
      var slides = getSlides(section);
      if (!main || !slides.length) return 0;
      var parts = getGalleryParts(main);
      if (!parts.view) return 0;
      var viewRect = parts.view.getBoundingClientRect();
      var best = 0;
      var bestDistance = Infinity;
      slides.forEach(function(slide, i) {
        var rect = slide.getBoundingClientRect();
        var distance = Math.abs(rect.left - viewRect.left);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    }


    function bindSmoothGalleryScroll(section) {
      var main = section.querySelector('[data-product-photos]');
      if (!main) return;
      var parts = getGalleryParts(main);
      var scrollTarget = parts.view || main;
      if (!scrollTarget || scrollTarget.dataset.amzQvSmoothScrollReady === 'true') return;
      scrollTarget.dataset.amzQvSmoothScrollReady = 'true';
      var scrollTimer = null;
      scrollTarget.addEventListener('scroll', function() {
        if (scrollTimer) window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function() {
          var slides = getSlides(section);
          var index = normalizeIndex(detectQuickViewSlideIndex(section), slides);
          var slide = slides[index];
          if (!slide) return;
          slides.forEach(function(item, i) {
            var active = i === index;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-hidden', active ? 'false' : 'true');
            item.setAttribute('tabindex', active ? '0' : '-1');
            forceSlideState(item, active);
          });
          forceSlideImage(slide);
          activateThumbs(section, index, null);
          syncThumbScroller(section, index, null);
        }, 80);
      }, { passive: true });
    }

    function forceSlideImage(slide) {
      if (!slide) return;
      slide.querySelectorAll('.image-wrap').forEach(function(wrap) {
        wrap.classList.add('loaded');
      });
      slide.querySelectorAll('amz-img-el').forEach(function(el) {
        el.classList.add('aos-animate');
        el.style.opacity = '1';
        el.style.visibility = 'visible';
        el.style.animation = 'none';
      });
      slide.querySelectorAll('img').forEach(function(img) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
        img.style.opacity = '1';
        img.style.visibility = 'visible';
        img.style.animation = 'none';
        img.style.backfaceVisibility = 'hidden';
        img.style.webkitBackfaceVisibility = 'hidden';
        img.style.transform = 'translateZ(0)';
        if (img.dataset && img.dataset.src && !img.getAttribute('src')) {
          img.setAttribute('src', img.dataset.src);
        }
        if (img.dataset && img.dataset.srcset && !img.getAttribute('srcset')) {
          img.setAttribute('srcset', img.dataset.srcset);
        }
        if (img.currentSrc || img.src) {
          var preloader = new Image();
          if (img.sizes) preloader.sizes = img.sizes;
          if (img.srcset) preloader.srcset = img.srcset;
          preloader.src = img.currentSrc || img.src;
        }
      });
    }

    function preloadNearbySlides(slides, index) {
      [index, index + 1, index - 1, index + 2].forEach(function(i) {
        if (i >= 0 && i < slides.length) forceSlideImage(slides[i]);
      });
    }

    function applyManualSlide(section, index, mediaId, smooth) {
      var main = section.querySelector('[data-product-photos]');
      var slides = getSlides(section);
      if (!main || !slides.length) return;
      index = normalizeIndex(index, slides);
      main.classList.add('amz-qv-manual-gallery');
      forceManualGalleryShell(main);
      var activeSlide = null;
      slides.forEach(function(slide, i) {
        var active = i === index || String(slide.dataset.index) === String(index);
        slide.classList.toggle('is-selected', active);
        slide.classList.toggle('starting-slide', active && index === 0);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.setAttribute('tabindex', active ? '0' : '-1');
        forceSlideState(slide, active);
        if (active) activeSlide = slide;
      });
      if (!activeSlide) activeSlide = slides[index];
      if (activeSlide) {
        activeSlide.classList.add('is-selected');
        activeSlide.setAttribute('aria-hidden', 'false');
        activeSlide.setAttribute('tabindex', '0');
        forceSlideState(activeSlide, true);
        forceSlideImage(activeSlide);
        scrollToQuickViewSlide(main, activeSlide, smooth !== false);
      }
      slides.forEach(function(slide) { forceSlideImage(slide); });
      preloadNearbySlides(slides, index);
      activateThumbs(section, index, mediaId);
      syncThumbScroller(section, index, mediaId);
      window.setTimeout(function() {
        forceManualGalleryShell(main);
        forceSlideState(activeSlide, true);
        forceSlideImage(activeSlide);
        scrollToQuickViewSlide(main, activeSlide, false);
      }, 180);
    }

    function selectQuickViewSlide(section, index, mediaId) {
      var slides = getSlides(section);
      if (!slides.length) return;
      index = normalizeIndex(index, slides);
      applyManualSlide(section, index, mediaId, true);
    }

    function getVariants(section) {
      if (section.amzQuickViewVariants) return section.amzQuickViewVariants;
      var json = section.querySelector('[data-variant-json]');
      if (!json) return [];
      try {
        section.amzQuickViewVariants = JSON.parse(json.value || json.textContent || '[]');
      } catch (err) {
        section.amzQuickViewVariants = [];
      }
      return section.amzQuickViewVariants;
    }

    function selectedOptions(section) {
      var values = [];
      var groups = toArray(section.querySelectorAll('.variant-input-wrap[data-index]'));
      groups.sort(function(a, b) {
        return (a.dataset.index || '').localeCompare(b.dataset.index || '');
      });
      groups.forEach(function(group) {
        var checked = group.querySelector('[data-variant-input]:checked');
        var select = group.querySelector('select[data-variant-input], select');
        if (checked) values.push(checked.value);
        else if (select) values.push(select.value);
      });
      return values;
    }

    function findSelectedVariant(section) {
      var select = section.querySelector('[data-product-select]');
      var variants = getVariants(section);
      if (select && select.value) {
        var byId = variants.find(function(variant) { return String(variant.id) === String(select.value); });
        if (byId) return byId;
      }
      var values = selectedOptions(section);
      if (!values.length) return null;
      return variants.find(function(variant) {
        if (!variant || !variant.options) return false;
        for (var i = 0; i < values.length; i += 1) {
          if (String(variant.options[i]) !== String(values[i])) return false;
        }
        return true;
      }) || null;
    }

    function selectVariantImage(section) {
      var variant = findSelectedVariant(section);
      if (!variant || !variant.featured_media || !variant.featured_media.id) return;
      var mediaId = variant.featured_media.id;
      var thumb = section.querySelector('[data-product-thumb][data-id="' + mediaId + '"], [data-amz-mobile-product-thumb][data-id="' + mediaId + '"]');
      if (!thumb) return;
      selectQuickViewSlide(section, normalizeIndex(thumb.dataset.index, null), mediaId);
    }

    function bindGallery(section) {
      if (section.dataset.amzQvGalleryReady === 'true') return;
      section.dataset.amzQvGalleryReady = 'true';

      section.addEventListener('click', function(event) {
        var thumb = event.target.closest ? event.target.closest('[data-product-thumb], [data-amz-mobile-product-thumb]') : null;
        if (!thumb || !section.contains(thumb)) return;
        event.preventDefault();
        event.stopPropagation();
        selectQuickViewSlide(section, normalizeIndex(thumb.dataset.index, null), thumb.dataset.id || null);
      }, true);

      section.addEventListener('change', function(event) {
        var target = event.target;
        if (!target || !target.matches || !(target.matches('[data-variant-input]') || target.matches('[data-product-select]') || target.matches('select'))) return;
        window.setTimeout(function() { selectVariantImage(section); }, 20);
        window.setTimeout(function() { selectVariantImage(section); }, 90);
        window.setTimeout(function() { selectVariantImage(section); }, 220);
      }, true);

      section.addEventListener('click', function(event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest('[data-variant-input], .variant-input, .color-swatch, .variant__button-label')) return;
        window.setTimeout(function() { selectVariantImage(section); }, 30);
        window.setTimeout(function() { selectVariantImage(section); }, 160);
      }, true);

      section.addEventListener('updateSwatch', function() {
        window.setTimeout(function() { selectVariantImage(section); }, 30);
        window.setTimeout(function() { selectVariantImage(section); }, 120);
      }, true);

      bindSmoothGalleryScroll(section);
    }

    modal.querySelectorAll('.product-section').forEach(function(section) {
      section.dataset.modal = 'true';
      section.removeAttribute('data-history');
      section.classList.add('is-modal');
      bindGallery(section);
      var initialThumb = section.querySelector('[data-product-thumb].is-active, [data-amz-mobile-product-thumb].is-active, [data-product-thumb], [data-amz-mobile-product-thumb]');
      applyManualSlide(section, initialThumb ? normalizeIndex(initialThumb.dataset.index, null) : 0, initialThumb ? initialThumb.dataset.id || null : null, false);
      bindSmoothGalleryScroll(section);
      window.setTimeout(function() { bindSmoothGalleryScroll(section); selectVariantImage(section); }, 60);
      section.querySelectorAll('[data-product-thumbs]').forEach(function(thumbs) {
        var scroller = thumbs.querySelector('.product__thumbs--scroller');
        if (!scroller) return;
        var vertical = thumbs.getAttribute('data-position') === 'beside';
        var prev = thumbs.querySelector('.product__thumb-arrow--prev');
        var next = thumbs.querySelector('.product__thumb-arrow--next');

        function updateArrows() {
          if (!prev || !next) return;
          prev.classList.remove('hide');
          next.classList.remove('hide');
          var max = vertical ? scroller.scrollHeight - scroller.clientHeight : scroller.scrollWidth - scroller.clientWidth;
          var current = vertical ? scroller.scrollTop : scroller.scrollLeft;
          var overflow = max > 2;
          prev.classList.toggle('amz-thumb-arrow-hidden', !overflow || current <= 2);
          next.classList.toggle('amz-thumb-arrow-hidden', !overflow || current >= max - 2);
        }

        function scrollByAmount(direction, smooth) {
          var amount = vertical ? Math.max(90, scroller.clientHeight * 0.82) : Math.max(90, scroller.clientWidth * 0.82);
          scroller.scrollBy({
            top: vertical ? amount * direction : 0,
            left: vertical ? 0 : amount * direction,
            behavior: smooth ? 'smooth' : 'auto'
          });
        }

        function bindArrow(button, direction) {
          if (!button || button.dataset.amzQvArrowReady === 'true') return;
          button.dataset.amzQvArrowReady = 'true';
          var timer = null;
          function clear() {
            if (timer) window.clearInterval(timer);
            timer = null;
          }
          button.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            scrollByAmount(direction, true);
            window.setTimeout(updateArrows, 180);
          }, true);
          button.addEventListener('pointerdown', function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            clear();
            scrollByAmount(direction, false);
            timer = window.setInterval(function() { scrollByAmount(direction, false); }, 160);
          }, true);
          ['pointerup', 'pointerleave', 'pointercancel'].forEach(function(name) {
            button.addEventListener(name, clear, true);
          });
        }

        function bindDrag() {
          if (scroller.dataset.amzQvDragReady === 'true') return;
          scroller.dataset.amzQvDragReady = 'true';
          var active = false;
          var moved = false;
          var start = 0;
          var scrollStart = 0;
          var pointerId = null;
          var suppressClick = false;

          scroller.querySelectorAll('img').forEach(function(img) {
            img.setAttribute('draggable', 'false');
          });

          function move(event) {
            if (!active || pointerId !== null && event.pointerId !== pointerId) return;
            var current = vertical ? event.clientY : event.clientX;
            var delta = current - start;
            if (!moved && Math.abs(delta) > 5) {
              moved = true;
              scroller.classList.add('is-amz-thumb-dragging');
            }
            if (!moved) return;
            if (event.cancelable) event.preventDefault();
            if (vertical) {
              scroller.scrollTop = scrollStart - delta;
            } else {
              scroller.scrollLeft = scrollStart - delta;
            }
            updateArrows();
          }

          function end(event) {
            if (!active || event && pointerId !== null && event.pointerId !== pointerId) return;
            active = false;
            pointerId = null;
            scroller.classList.remove('is-amz-thumb-dragging');
            document.removeEventListener('pointermove', move, false);
            document.removeEventListener('pointerup', end, false);
            document.removeEventListener('pointercancel', end, false);
            if (moved) {
              suppressClick = true;
              window.setTimeout(function() { suppressClick = false; }, 120);
            }
          }

          scroller.addEventListener('pointerdown', function(event) {
            if (typeof event.button === 'number' && event.button !== 0) return;
            active = true;
            moved = false;
            pointerId = typeof event.pointerId === 'number' ? event.pointerId : null;
            start = vertical ? event.clientY : event.clientX;
            scrollStart = vertical ? scroller.scrollTop : scroller.scrollLeft;
            document.addEventListener('pointermove', move, { passive: false });
            document.addEventListener('pointerup', end, false);
            document.addEventListener('pointercancel', end, false);
          }, true);

          scroller.addEventListener('click', function(event) {
            if (!suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
          }, true);
        }

        bindArrow(prev, -1);
        bindArrow(next, 1);
        bindDrag();
        if (scroller.dataset.amzQvScrollReady !== 'true') {
          scroller.dataset.amzQvScrollReady = 'true';
          scroller.addEventListener('scroll', updateArrows, { passive: true });
        }
        updateArrows();
        window.setTimeout(updateArrows, 250);
        window.setTimeout(updateArrows, 900);
      });
      window.setTimeout(function() { selectVariantImage(section); }, 180);
      window.setTimeout(function() { selectVariantImage(section); }, 520);
    });
  };

  document.addEventListener('quickview:open', function(evt) {
    var modal = evt && evt.detail ? document.getElementById('QuickShopModal-' + evt.detail.productId) : null;
    if (apx.quickViewEnhancements) apx.quickViewEnhancements(modal || document);
  });

  document.addEventListener('quickview:loaded', function(evt) {
    var modal = evt && evt.detail ? document.getElementById('QuickShopModal-' + evt.detail.productId) : null;
    if (apx.quickViewEnhancements) apx.quickViewEnhancements(modal || document);
  });
  
  // apx.Slideshow handles all slider instances
  // Child navigation is only setup to work on product images
  apx.Slideshow = (function() {
    var classes = {
      animateOut: 'amz-anim-out',
      isPaused: 'amz-is-paused',
      isActive: 'is-active'
    };
  
    var selectors = {
      allSlides: '.amz-sw__slide',
      currentSlide: '.is-selected',
      wrapper: '.amz-sw-wrapper',
      pauseButton: '.amz-sw__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, 
      childNav: null, // element
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: apx.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new ApxSlider(el, this.args);
  
      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      window.on('resize', apx.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
  
      // Set amz-fc-view height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .amz-fc-view{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
  
        if (apx.refreshAOS) { apx.refreshAOS(false) }
      },
  
      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
  
        this.slideshow.destroy();
      },
      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
  
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (!this.args.childNavScroller) {
          return;
        }
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/
  
  apx.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled'
    };
  
    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;
  
      this.init();
    }
  
    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));
  
        // Set default state based on current selected variant
        this.setInitialAvailability();
      },
  
      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {
  
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
  
            if (variant[index] === null) return;
  
            let entry = options[index].find(option => option.value === variant[index]);
  
            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {value: variant[index], soldOut: true}
              options[index].push(entry);
            }
  
            const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')
  
            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })
  
          return options;
        }, { option1: [], option2: [], option3: []})
      },
  
      setInitialAvailability: function() {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
  
        const currentlySelectedValues = this.currentVariantObject.options.map((value,index) => {return {value, index: `option${index+1}`}})
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);
  
        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },
  
      setAvailability: function(evt) {
  
        const {value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant} = evt.detail;
  
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)
  
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },
  
      manageOptionState: function(option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="'+ option +'"]');
  
        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      },
  
      enableVariantOption: function(group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (this.type === 'dropdown') {
          if (obj.soldOut) {
            group.querySelector('option[value="'+ value +'"]').disabled = true;
          } else {
            group.querySelector('option[value="'+ value +'"]').disabled = false;
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');
  
          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);
  
          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },
  
      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }
  
    });
  
    return availability;
  })();
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  apx.videoModal = function() {
    var youtubePlayer;
    var vimeoPlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      apx.LibraryLoader.load('youtubeSdk');
    }
  
    if (vimeoTriggers.length) {
      apx.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }
  
    var modal = new apx.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!apx.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new apx.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!apx.config.vimeoReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new apx.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  
  
  /*============================================================================
    ToolTip
  ==============================================================================*/
  
  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');
  
      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');
  
      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }
  
    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;
  
      // Ensure we set a title for product availability
      if (context != 'amz-sa') {
        this.toolTipTitle.remove();
      }
  
      this._lockScrolling();
  
      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }
  
      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });
  
      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });
  
      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }
  
    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';
  
      this._unlockScrolling();
  
      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }
  
    _lockScrolling() {
      apx.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      apx.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }
  
    _unlockScrolling() {
      apx.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      apx.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }
  
  customElements.define('tool-tip', ToolTip);
  
  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/
  
  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }
  
    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });
  
      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }
  
  customElements.define('tool-tip-trigger', ToolTipTrigger);
  
  /*============================================================================
    NewsletterReminder
  ==============================================================================*/
  
  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');
  
      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${ this.id }`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new apx.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');
  
      this.init();
    }
  
    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true)
        }
      });
  
      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });
  
      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));
  
      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
      });
  
      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
        this.dispatchEvent(reminderOpen);
  
        this.hide();
      });
    }
  
    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          sessionStorage.setItem('reminderAppeared', true);
        }, time * 1000);
      }
    }
  
    hide() {
      this.dataset.enabled = 'false';
    }
  }
  
  customElements.define('newsletter-reminder', NewsletterReminder);
  
  /*============================================================================
    ImageElement
  ==============================================================================*/
  
  class ImageElement extends HTMLElement {
    constructor() {
      super();
  
      this.init();
    }
  
    init() {
  
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
  
        this.removeAnimations();
  
        observer.unobserve(this);
      }
  
      // Set an IntersectionObserver to check if the image is nearly in the viewport
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  
    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest('.image-wrap');
      const skrimWrap = this.closest('.skrim__link');
  
      if (imageWrap) {
        imageWrap.classList.add('loaded');
      }
  
      if (skrimWrap) {
        skrimWrap.classList.add('loaded');
      }
    }
  }
  
  customElements.define('amz-img-el', ImageElement);
  
  /*============================================================================
    PredictiveSearch
  ==============================================================================*/
  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.SearchModal = this.closest('#SearchModal') || null;
  
      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');
  
        // Wait for opening events to finish then apply focus
        setTimeout(() => { this.input.focus(); }, 100);
  
        document.body.classList.add('predictive-overflow-hidden');
      });
  
      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { this.input.focus(); }, 100);
              }
            }
          });
        });
  
        observer.observe(this.SearchModal, {
          attributes: true
        });
      }
  
      if (this.enabled === 'false') return;
  
      // On typing
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
  
      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
      this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
      this.screen.addEventListener('click', () => { this.close(); });
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) return;
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      const searchObj = {
        'q': searchTerm,
        'resources[limit]': 3,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };
  
      const params = this.paramUrl(searchObj);
  
      fetch(`${apx.routes.predictiveSearch}?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
  
          if (apx.refreshAOS) { apx.refreshAOS(true); }
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
  
      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  
    paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  
  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
      this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
      this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
      this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
      this.dateInput = this.querySelector(`#Recipient-send-on-${ this.dataset.sectionId }`);
      this.addEventListener('change', () => this.onChange());
      this.recipientFields = this.querySelector('.recipient-fields');
  
      this.checkboxInput.addEventListener('change', () => {
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
      });
    }
  
    connectedCallback() {
      document.addEventListener('ajaxProduct:error', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.displayErrorMessage(event.detail.errorMessage);
        }
      });
  
      document.addEventListener('ajaxProduct:added', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      });
    }
  
    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  
    clearInputFields() {
      this.querySelectorAll('.field__input').forEach(el => el.value = '');
    }
  
    displayErrorMessage(body) {
      this.clearErrorMessage();
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;
  
          inputElement.setAttribute('aria-invalid', true);
          inputElement.classList.add('field__input--error');
        });
      }
    }
  
    clearErrorMessage() {
      this.querySelectorAll('.field__input').forEach(inputElement => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
        inputElement.classList.remove('field__input--error');
      });
    }
  };
  
  customElements.define('recipient-form', RecipientForm);
  

  apx.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: apx.config.rtl ? 'right' : 'left'
    };
    var bar;
    var apxSlider;
  
    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }
  
      unload();
  
      if (bar.dataset.blockCount === 1) {
        return;
      }
  
      if (apx.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }
  
      document.addEventListener('matchSmall', function() {
        unload();
        initSlider();
      });
  
      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }
  
    function initSlider() {
      apxSlider = new apx.Slideshow(bar, args);
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);
  
      if (apxSlider && typeof apxSlider.pause === 'function') {
        apxSlider.goToSlide(index);
        apxSlider.pause();
      }
    }
  
    function onBlockDeselect() {
      if (apxSlider && typeof apxSlider.play === 'function') {
        apxSlider.play();
      }
    }
  
    function unload() {
      if (apxSlider && typeof apxSlider.destroy === 'function') {
        apxSlider.destroy();
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  apx.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  apx.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new apx.Drawers('CartDrawer', 'cart');
  
      this.init();
    }
  
    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new apx.CartForm(this.form);
        this.cartForm.apxBuildCart();
  
        document.addEventListener('ajaxProduct:added', function(evt) {
          this.open();
          window.requestAnimationFrame(function() {
            this.cartForm.apxBuildCart();
          }.bind(this));
        }.bind(this));
  
        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },
  
      open: function() {
        this.drawer.open();
  
        apx.a11y.trapFocus({
          container: this.form,
          elementToFocus: this.form,
          namespace: 'cartdrawer_focus'
        });
      },
  
      close: function() {
        this.drawer.close();
  
        apx.a11y.removeTrapFocus({
          container: this.form,
          namespace: 'cartdrawer_focus'
        });
      }
    });
  
    return CartDrawer;
  })();
  
  apx.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.amz-hdr__srch-wrap',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.amz-nav__item',
      navLinks: '.amz-nav__lnk',
      navLinksWithDropdown: '.amz-nav__lnk--has-dd',
      navDropdownLinks: '.amz-nav__dd-lnk--l2',
      navDetails: '.amz-nav__details',
    };
  
    var classes = {
      hasDropdownClass: 'amz-nav--has-dd',
      hasSubDropdownClass: 'amz-nav__deep-dd-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'amz-hdr--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'amz-hdr--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
  
    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);
  
      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }
  
      apx.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (apx.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }
  
      menuDetailsHandler();
      searchDrawer();
    }
  
    function menuDetailsHandler() {
      const navDetails = document.querySelectorAll(selectors.navDetails);
  
      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector('summary');
  
        // if the navDetail is open, then close it when the user clicks outside of it
        document.addEventListener('click', (evt) => {
          if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
            navDetail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            if (navDetail.hasAttribute('open')) {
              summary.setAttribute('aria-expanded', 'false');
            } else {
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      apx.settings.overlayHeader = false;
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      apx.config.stickyHeader = doesMegaMenuFit();
  
      if (apx.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
  
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
  
      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      apx.utils.wrap(siteHeader, wrapWith);
  
      stickyHeaderInitialPosition(siteHeader);
      stickyHeaderHeight();
  
      window.on('resize' + config.namespace, apx.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, apx.utils.throttle(20, stickyHeaderScroll));
  
      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }
  
    function stickyHeaderInitialPosition(header) {
      const headerParent = header.closest('.shopify-section-group-header-group');
      const parentNextSibling = headerParent.nextElementSibling;
  
      // if parentNextSibling has same class as headerParent, then header is above announcement bar
      if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
        // get height of announcement bar and set header wrapper top to that value
        const nextSiblingHeight = parentNextSibling.offsetHeight;
        document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
      }
    }
  
    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
  
      var h = siteHeader.offsetHeight;
  
      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('amz-hdr--stuck') && !apx.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }
  
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }
  
    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }
  
      if (config.forceStopSticky) {
        return;
      }
  
      requestAnimationFrame(scrollHandler);
  
      config.lastScroll = window.scrollY;
    }
  
    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }
  
        config.stickyActive = true;
  
        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;
  
        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }
  
    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          document.dispatchEvent(new CustomEvent('predictive-search:open', {
            detail: {
              context: 'header'
            },
            bubbles: true
          }));
  
          // add is-active class to .amz-hdr__srch-wrap
          document.querySelector(selectors.searchContainer).classList.add('is-active');
        });
      });
  
      document.addEventListener('predictive-search:close-all', function() {
        closeSearchDrawer();
      });
    }
  
    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('amz-hdr__srch-btn')) {
              break;
            }
  
            if (path[i].classList.contains('amz-hdr__srch-wrap')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), apx.drawerAnimationTime ? apx.drawerAnimationTime('close') : 410);
  
      var container = document.querySelector(selectors.searchContainer);
      apx.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();
  
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };
  
  apx.buildProductGridItem = function(items, gridWidth, rowOf, imageSizes) {
  var output = '';

  items.forEach(function(product) {
    var settings = apx.settings || {};
    var priceStyle = apx.collectionPriceStyle || {};
    var image = apx.buildProductImage(product, imageSizes);

    // Helpers: prefer priceStyle values, then settings, then fallback
    function pick(key, fallback) {
      if (priceStyle[key] !== undefined && priceStyle[key] !== null) return priceStyle[key];
      if (settings[key] !== undefined && settings[key] !== null) return settings[key];
      return fallback;
    }

    // -------------------------
    // Title truncation (Collection Price Style)
    // -------------------------
    var title = product.title;
    var truncateEnable = pick('product_grid_title_truncate_enable', false);
    var wordLimit = parseInt(pick('product_grid_title_word_limit', 3), 10);

    if (truncateEnable) {
      var words = String(title).trim().split(/\s+/);
      if (words.length > wordLimit) {
        title = words.slice(0, wordLimit).join(' ') + '…';
      }
    }

    // Vendor (leave as theme behavior)
    var vendorHtml = '';
    if (settings.predictiveSearchVendor) {
      vendorHtml = '<div class="amz-gp__vendor">' + product.vendor + '</div>';
    }

    // -------------------------
    // Price calculations
    // -------------------------
    var regularPrice = product.price;
    var comparePrice = product.compare_at_price;
    var available = product.available !== false;
    var onSale = comparePrice && comparePrice > regularPrice && available;

    // -------------------------
    // Sale badge (Collection Price Style)
    // -------------------------
    var saleEnable = pick('product_grid_sale_badge_enable', true);
    var saleBadgeHtml = '';

    if (onSale && saleEnable) {
      var saleStyle = pick('product_grid_sale_badge_style', 'simple');
      var saleBadgeText = '';

      if (saleStyle === 'percent') {
        var percentVal = Math.round(((comparePrice - regularPrice) * 100) / comparePrice);
        var percentFormat = pick('product_grid_sale_badge_percent_text', '-{percent}%');
        saleBadgeText = String(percentFormat).replace('{percent}', String(percentVal));
      } else if (saleStyle === 'amount') {
        var amountVal = apx.Currency.formatMoney(comparePrice - regularPrice, apx.moneyFormat);
        var amountFormat = pick('product_grid_sale_badge_value_text', '-{amount}');
        saleBadgeText = String(amountFormat).replace('{amount}', amountVal);
      } else {
        saleBadgeText = pick('product_grid_sale_badge_simple_text', 'Sale');
      }

      var posClass = pick('product_grid_sale_badge_position', 'top-right');

      var badgeStyles = '';
      var saleBg = pick('color_sale_tag', '#ef4444');
      var saleFg = pick('color_sale_tag_text', '#ffffff');

      badgeStyles += 'background-color:' + saleBg + ';';
      badgeStyles += 'color:' + saleFg + ';';
      badgeStyles += 'font-size:' + pick('product_grid_sale_badge_font_size', 14) + 'px;';
      badgeStyles += 'padding:' + pick('product_grid_sale_badge_padding_y', 4) + 'px ' + pick('product_grid_sale_badge_padding_x', 6) + 'px;';
      badgeStyles += 'border-radius:' + pick('product_grid_sale_badge_radius', 6) + 'px;';

      // Position spacing
      if (posClass.indexOf('top') !== -1) {
        badgeStyles += 'top:' + pick('product_grid_sale_badge_spacing_top', 16) + 'px;';
      } else {
        badgeStyles += 'bottom:' + pick('product_grid_sale_badge_spacing_bottom', 16) + 'px;';
      }
      if (posClass.indexOf('right') !== -1) {
        badgeStyles += 'right:' + pick('product_grid_sale_badge_spacing_right', 16) + 'px;';
      } else {
        badgeStyles += 'left:' + pick('product_grid_sale_badge_spacing_left', 16) + 'px;';
      }

      saleBadgeHtml =
        '<div class="amz-gp__tag amz-gp__tag--sale amz-gp__tag--' +
        posClass +
        '" style="' +
        badgeStyles +
        '">' +
        saleBadgeText +
        '</div>';
    }

    // -------------------------
    // Savings badge (Collection Price Style)
    // -------------------------
    var saveEnable = pick('save_enable', true);
    var saveHtml = '';

    if (saveEnable && onSale && comparePrice > regularPrice) {
      var saveFormat = pick('save_format', 'percent'); // percent|amount
      var savedVal = '';

      if (saveFormat === 'amount') {
        savedVal = apx.Currency.formatMoney(comparePrice - regularPrice, apx.moneyFormat);
      } else {
        var svPerc = Math.round(((comparePrice - regularPrice) * 100) / comparePrice);
        savedVal = String(svPerc) + '%';
      }

      var label = pick('save_label', 'Save');
      var savePosition = pick('save_position', 'after'); // before|after
      var saveText = (savePosition === 'before') ? (savedVal + ' ' + label) : (label + ' ' + savedVal);

      var saveStyles = '';
      saveStyles += 'color:' + pick('save_text_color', '#ef4444') + ';';
      saveStyles += 'background:' + pick('save_bg_color', '#ffffff') + ';';
      saveStyles += 'font-size:' + pick('save_size', 15) + 'px;';
      saveStyles += 'font-weight:' + pick('save_weight', 500) + ';';
      saveStyles += 'padding:' + pick('save_pad_y', 4) + 'px ' + pick('save_pad_x', 2) + 'px;';
      saveStyles += 'border-radius:' + pick('save_radius', 6) + 'px;';

      saveHtml = '<span class="amz-gp__price--save" style="' + saveStyles + '">' + saveText + '</span>';
    }

    // -------------------------
    // Price HTML (Collection Price Style)
    // -------------------------
    var currentHtml = '';
    var regularHtml = '';
    var compareHtml = '';

    if (onSale) {
      var curColor = pick('cur_color', '#39b57b');
      var curSize = pick('cur_size', 15);
      var curWeight = pick('cur_weight', 600);
      var curPad = pick('cur_pad_x', 2);

      currentHtml =
        '<span class="amz-gp__price--current" style="color:' +
        curColor +
        ';font-size:' +
        curSize +
        'px;font-weight:' +
        curWeight +
        ';padding-left:' +
        curPad +
        'px;padding-right:' +
        curPad +
        'px;">' +
        apx.Currency.formatMoney(regularPrice, apx.moneyFormat) +
        '</span>';

      var cmpColor = pick('cmp_color', '#999999');
      var cmpSize = pick('cmp_size', 15);
      var cmpWeight = pick('cmp_weight', 400);
      var cmpPad = pick('cmp_pad_x', 0);

      compareHtml =
        '<span class="amz-gp__price--orig" style="color:' +
        cmpColor +
        ';font-size:' +
        cmpSize +
        'px;font-weight:' +
        cmpWeight +
        ';padding-left:' +
        cmpPad +
        'px;padding-right:' +
        cmpPad +
        'px;">' +
        apx.Currency.formatMoney(comparePrice, apx.moneyFormat) +
        '</span>';
    } else {
      var regColor = pick('reg_color', '#111111');
      var regSize = pick('reg_size', 15);
      var regWeight = pick('reg_weight', 500);

      regularHtml =
        '<span class="amz-gp__price--regular" style="color:' +
        regColor +
        ';font-size:' +
        regSize +
        'px;font-weight:' +
        regWeight +
        ';">' +
        apx.Currency.formatMoney(regularPrice, apx.moneyFormat) +
        '</span>';
    }

    // -------------------------
    // Ordering (Collection Price Style)
    // -------------------------
    var p1 = parseInt(pick('order_current', 2), 10);
    var p2 = parseInt(pick('order_compare', 1), 10);
    var p3 = parseInt(pick('order_save', 3), 10);
    var p4 = parseInt(pick('order_regular', 1), 10);

    var pricePieces = '';
    [1, 2, 3, 4].forEach(function(i) {
      if (p1 === i) pricePieces += currentHtml;
      if (p2 === i) pricePieces += compareHtml;
      if (p3 === i) pricePieces += saveHtml;
      if (p4 === i) pricePieces += regularHtml;
    });

    var priceHtml = '<div class="amz-gp__price">' + pricePieces + '</div>';

    // -------------------------
    // Build markup
    // -------------------------
    var markup = '';
    markup += '<div class="grid__item amz-gp ' + gridWidth + ' aos-animate" data-aos="row-of-' + rowOf + '">';
    markup +=   '<div class="amz-gp__body">';
    markup +=     '<a href="' + product.url + '" class="amz-gp__lnk">';
    markup +=       '<div class="amz-gp__img-mask" style="position:relative;">';
    markup +=         saleBadgeHtml + image;
    markup +=       '</div>';
    markup +=       '<div class="amz-gp__meta">';
    markup +=         '<div class="amz-gp__ttl">' + title + '</div>';
    markup +=         priceHtml + vendorHtml;
    markup +=       '</div>';
    markup +=     '</a>';
    markup +=   '</div>';
    markup += '</div>';

    output += markup;
  });

  return output;
};
  
  apx.buildProductImage = function(product, imageSizes) {
    var size = apx.settings.productImageSize;
    var output = '';
  
    if (size === 'natural') {
      const template = document.getElementById("naturalImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.image-wrap');
  
      imageWrapperEl.style.paddingBottom = `${product.image_aspect_ratio}%`;
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
    } else {
      const template = document.getElementById("fixedRatioImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.grid__image-ratio');
  
      imageWrapperEl.classList.add(`grid__image-ratio--${size}`);
  
      if (!apx.settings.productImageCover) {
        imageEl.classList.add('grid__image-contain');
      }
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
    }
  
    function addImageProperties(imageEl, imageSizes) {
      imageEl.src = product.image_responsive_url;
      imageEl.srcset = product.image_responsive_urls.toString();
      imageEl.alt = product.title;
      imageEl.sizes = imageSizes;
    }
  
    return output;
  }
  

  /*============================================================================
    Age Verification Popup
  ==============================================================================*/
  
  class AgeVerificationPopup extends HTMLElement {
    constructor() {
      super();
  
      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);
  
      this.classes = {
        activeContent: 'age-verification-popup__content--active',
        inactiveContent: 'age-verification-popup__content--inactive',
        inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
        activeDeclineContent: 'age-verification-popup__decline-content--active',
      }
  
      this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
      this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
      this.content = this.querySelector('[data-age-verification-popup-content]');
      this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
      this.exitButton = this.querySelector('[data-age-verification-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');
  
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        })
  
        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
  
            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }
  
            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);
  
            if (!secondViewVisited) return;
  
            this.showDeclineContent();
          }
        })
  
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.modal.close();
          }
        })
      }
  
      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR visibility is toggled in the editor
      if ((this.cookie) && this.dataset.testMode === 'false') return;
  
      this.init();
    }
  
    init() {
      this.modal = new apx.Modals(this.id, 'age-verification-popup-modal', {
        closeOffContentClick: false
      });
  
      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }
  
      if (apx.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }
  
      this.modal.open();
  
      apx.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
  
      if (this.declineButton) {
        this.declineButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showDeclineContent();
  
          // If in editor, save to session storage to indicate that user has moved on to the second view
          // Allows view to persist while making changes in the editor
          if (Shopify.designMode) {
            sessionStorage.setItem(this.id, 'second-view');
          }
        });
      }
  
      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();
  
          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);
  
          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }
  
      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();
  
          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30, sameSite: 'none', secure: true });
          }
  
          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }
  
          if (apx.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }
  
          this.modal.close();
  
          apx.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }
  
    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);
  
      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }
  
    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);
  
      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }
  
  customElements.define('age-verification-popup', AgeVerificationPopup);
  
  
  
  apx.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-apx-section="map"]',
      map: '[data-map]',
      mapOverlay: '.amz-map__overlay'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(apx.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;
  
      errors = {
        addressNoResults: apx.strings.addressNoResults,
        addressQueryLimit: apx.strings.addressQueryLimit,
        addressError: apx.strings.addressError,
        authError: apx.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      apx.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                apx.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
  
              if (Shopify.designMode) {
                if (apx.refreshAOS) { apx.refreshAOS(true) }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });
  
    return Map;
  })();
  
  apx.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
  
      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };
  
      this.modal = new apx.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.cookie) {
        this.initPopupDelay();
      }
  
      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            sessionStorage.setItem('newsletterAppeared', true);
          }
  
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },
  
      onLoad: function () {
        this.modal.open();
      },
  
      onSelect: function () {
        this.modal.open();
      },
  
      onDeselect: function () {
        this.modal.close();
      },
  
      onBlockSelect: function () {
        this.modal.close();
      },
  
      onBlockDeselect: function () {
        this.modal.open();
      },
  
      onUnload: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();
  
  apx.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }
  
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }
  
        var passwordModal = new apx.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });
  
        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });
  
    return PasswordHeader;
  })();
  
  apx.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.amz-fc-view ',
      activeImage: '.is-selected'
    };
  
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
  
      if (!container || container.dataset.zoom === 'false') {
        return;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },
  
      triggerClick: function(evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }
  
        this.items = this.getImageData();
  
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;
  
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
  
        this.initGallery(this.items, index);
      },
  
      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }
  
        // 1-based index required
        return i + 1;
      },
  
      getImageData: function() {
        this.images = this.inSlideshow
                        ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                        : this.container.querySelectorAll(selectors.images);
  
        var items = [];
        var options = {};
  
        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.gallery.init();
  
        this.preventiOS15Scrolling();
      },
  
      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },
  
      syncHeight: function() {
        document.documentElement.style.setProperty(
          "--window-inner-height", 
          `${window.innerHeight}px`
        );
      },
  
      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function() {
        let initialScrollPos;
  
        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return; 
        
        this.syncHeight();
              
        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;
        
        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');
  
        window.addEventListener('resize', this.syncHeight);
      
        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, initialScrollPos);
        });
      }
    });
  
    return Photoswipe;
  })();
  
  
  /*============================================================================
    ProductRecommendations
  ==============================================================================*/
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.url = this.dataset.url;
      this.intent = this.dataset.intent;
      this.placeholder = this.querySelector('.product-recommendations-placeholder');
      this.productResults =  this.querySelector('.amz-gp');
      this.sectionId = this.dataset.sectionId;
      this.blockId = this.dataset.blockId;
  
      document.addEventListener('recommendations:loaded', (e) => {
        this.colorImages = this.el.querySelectorAll('.amz-gp__color-img');
        if (this.colorImages.length) {
          this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
          this.colorSwatchHovering();
        }
      });
    }
  
    connectedCallback() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
  
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
  
        if (!recommendations) {
          this.el.classList.add('hide');
          if (apx.refreshAOS) { apx.refreshAOS(true) }
          return;
        }
  
        this.placeholder.innerHTML = '';
        this.placeholder.innerHTML = recommendations.innerHTML;
  
        apx.reinitProductGridItem(this.el);
  
        this.slideshow = this.querySelector('[data-slideshow]');
  
        if (this.slideshow) {
          this.setupSlider();
        }
  
        document.dispatchEvent(new CustomEvent('recommendations:loaded', {
          detail: {
            section: this.el,
            intent: this.intent
          }
        }));
  
        })
        .catch(e => {
          console.error(e);
        });
    }
  
    setupSlider() {
      const controlType = this.slideshow.dataset.controls;
      const perSlide = parseFloat(this.slideshow.dataset.perSlide);
      const count = parseFloat(this.slideshow.dataset.count);
  
      let prevNextButtons = false;
      let pageDots = true;
  
      if (controlType === 'arrows') {
        pageDots = false;
        prevNextButtons = true;
      }
  
      if (perSlide < count) {
        this.apxSlider = new apx.Slideshow(this.slideshow, {
          prevNextButtons,
          pageDots,
          adaptiveHeight: true,
          wrapAround: false,
        });
      }
    }
  
    colorSwatchHovering() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this.setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this.removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      const imageEl = this.el.querySelector(`.amz-gp__color-img--${id}`);
  
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }
  
    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.amz-gp__color-img--${id}`).classList.remove('is-active');
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  
  apx.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.amz-plx-wrap'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      this.initialIndex = 0;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        apx.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = Array.from(this.slideshow.querySelectorAll('.amz-sw__slide'));
        var hero = this.slideshow;
        var markLoaded = function() {
          hero.classList.remove('loading', 'amz-load--delayed');
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(function() { hero.classList.add('loaded'); });
          } else {
            hero.classList.add('loaded');
          }
        };

        if (slides.length <= 1) {
          if (slides.length) slides[0].classList.add('is-selected');
          markLoaded();
          return;
        }

        var speed   = hero.dataset.autoplay === 'true' ? parseInt(hero.dataset.speed, 10) || parseInt(apx.animationValue ? apx.animationValue('sliderAutoplayDelay', 5000) : 5000, 10) || 5000 : false;
        var hasDots = hero.hasAttribute('data-dots');
        var total   = slides.length;
        var current = Math.max(0, Math.min(this.initialIndex || 0, total - 1));
        var timer   = null;
        var paused  = false;
        var self    = this;

        slides.forEach(function(s) {
          s.style.display    = 'block';
          s.style.position   = 'absolute';
          s.style.top        = '0';
          s.style.left       = '0';
          s.style.width      = '100%';
          s.style.height     = '100%';
          s.style.opacity    = '0';
          s.style.zIndex     = '1';
          s.style.transition = 'opacity ' + (parseInt(apx.animationValue ? apx.animationValue('sliderSpeed', 520) : 520, 10) || 520) + 'ms var(--amz-anim-ease, ease)';
        });

        function activate(idx, skipTransition) {
          var prev = current;
          current  = ((idx % total) + total) % total;

          slides[prev].classList.remove('is-selected');
          slides[prev].classList.add('amz-anim-out');
          slides[prev].style.opacity = '0';
          slides[prev].style.zIndex  = '1';
          setTimeout(function() { slides[prev].classList.remove('amz-anim-out'); }, parseInt(apx.animationValue ? apx.animationValue('sliderSpeed', 520) : 520, 10) || 520);

          slides[current].classList.add('is-selected');
          slides[current].style.opacity = skipTransition ? '1' : '1';
          slides[current].style.zIndex  = '2';

          if (dots && dotEls.length) {
            dotEls.forEach(function(d, i) { d.classList.toggle('is-selected', i === current); });
            if (hero.hasAttribute('data-bars')) {
              var old   = dotEls[current];
              var clone = old.cloneNode(true);
              clone.classList.add('is-selected');
              clone.addEventListener('click', makeGoHandler(current));
              old.parentNode.replaceChild(clone, old);
              dotEls[current] = clone;
            }
          }
          if (apx.refreshAOS) apx.refreshAOS(false);
        }

        function makeGoHandler(idx) {
          return function() { go(idx); };
        }

        function go(idx) {
          activate(idx, false);
          if (speed) restart();
        }

        function startTimer() {
          if (!speed || paused) return;
          timer = setInterval(function() { go((current + 1) % total); }, speed);
        }

        function stopTimer() {
          clearInterval(timer);
          timer = null;
        }

        function restart() {
          stopTimer();
          startTimer();
        }

        var dots   = null;
        var dotEls = [];
        if (hasDots) {
          dots = document.createElement('ol');
          dots.className = 'amz-fc-dots';
          slides.forEach(function(_, i) {
            var li = document.createElement('li');
            li.className = 'dot' + (i === current ? ' is-selected' : '');
            li.setAttribute('role', 'button');
            li.addEventListener('click', makeGoHandler(i));
            dots.appendChild(li);
            dotEls.push(li);
          });
          hero.appendChild(dots);
        }

        var wrapper  = hero.closest('.amz-sw-wrapper');
        var pauseBtn = wrapper && wrapper.querySelector('.amz-sw__pause');
        if (pauseBtn) {
          pauseBtn.addEventListener('click', function() {
            paused = !paused;
            pauseBtn.classList.toggle('amz-is-paused', paused);
            paused ? stopTimer() : startTimer();
          });
        }

        var touchStartX = null;
        hero.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].pageX; }, { passive: true });
        hero.addEventListener('touchend', function(e) {
          if (touchStartX === null) return;
          var dx = e.changedTouches[0].pageX - touchStartX;
          touchStartX = null;
          if (Math.abs(dx) > 40) go(dx < 0 ? (current + 1) % total : (current - 1 + total) % total);
        });

        slides[current].classList.add('is-selected');
        slides[current].style.opacity = '1';
        slides[current].style.zIndex  = '2';
        markLoaded();

        this._apexSlides   = slides;
        this._apexDots     = dots;
        this._apexDotEls   = dotEls;
        this._apexGetIdx   = function() { return current; };
        this._apexGo       = go;
        this._apexStop     = stopTimer;
        this._apexSpeed    = speed;
        this._apexPaused   = function() { return paused; };

        startTimer();
      },

      forceReload: function() {
        this.onUnload();
        this.init();
      },

      onUnload: function() {
        if (this._apexStop) this._apexStop();
        if (this._apexDots && this._apexDots.parentNode) this._apexDots.parentNode.removeChild(this._apexDots);
        if (this._apexSlides) {
          this._apexSlides.forEach(function(s) {
            s.classList.remove('is-selected', 'amz-anim-out');
            s.removeAttribute('style');
          });
        }
        this._apexSlides = null;
        this._apexDots   = null;
        this._apexGo     = null;
        this._apexStop   = null;
      },

      onDeselect: function() {
        if (this._apexSpeed && !this._apexPaused || !this._apexGo) return;
        if (this._apexSpeed && this._apexGo) this._apexGo(this._apexGetIdx());
      },

      onBlockSelect: function(evt) {
        if (this._apexGo && this._apexSlides) {
          var slide = this.slideshow.querySelector('.amz-sw__slide--' + evt.detail.blockId);
          if (slide) {
            var idx = this._apexSlides.indexOf(slide);
            if (idx >= 0) { this._apexGo(idx); this._apexStop(); }
          }
        } else {
          this.initialIndex = parseInt(
            (this.slideshow.querySelector('.amz-sw__slide--' + evt.detail.blockId) || {}).dataset && 
            this.slideshow.querySelector('.amz-sw__slide--' + evt.detail.blockId).dataset.index || 0
          );
        }
      },

      onBlockDeselect: function() {
        if (this._apexGo && this._apexSpeed && !this._apexPaused()) {
          this._apexGo(this._apexGetIdx());
        }
      }
    });
  
    return SlideshowSection;
  })();
  
  apx.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };
  
    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }
  
    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=amz-sa';
  
        var self = this;
  
        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }
  
            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
  
            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new apx.Drawers('StoreAvailabilityDrawer', 'availability');
            }
  
            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new apx.Modals('StoreAvailabilityModal', 'availability');
            }
  
            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      }
    });
  
    return StoreAvailability;
  })();
  
  apx.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      apx.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new apx.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new apx.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  
  /*============================================================================
    CountdownTimer
  ==============================================================================*/
  
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;
  
      this.timerComplete = false;
  
      this.init();
    }
  
    init() {
      this._calculate();
      if (!this.timerComplete) {
        this.intervalId = setInterval(() => {
          this._calculate();
          if (this.timerComplete && this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
        }, 1000);
      }
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  
    _calculate() {
      // Find time difference and convert to integer
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };
  
        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;
  
        setTimeout(() => {
          this.display.classList.add('countdown__display--loaded');
        }, 1);
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }
  
        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }
  
        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }
  
        this.timerComplete = true;
      }
    }
  }
  
  customElements.define('countdown-timer', CountdownTimer);
  
  /*============================================================================
    HotSpots
  ==============================================================================*/
  
  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll('[data-button]');
      this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]');
      this.blockContainer = this.querySelector('[data-block-container]');
      this.colorImages = this.querySelectorAll('.amz-gp__color-img');
      this.colorSwatches = this.querySelectorAll('.color-swatch--with-image');
  
      this._bindEvents();
      this._setupQuickShop();
  
      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }
  
    _colorSwatchHovering() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this._setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this._setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this._removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.colorSwatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      var imageEl = this.el.querySelector('.amz-gp__color-img--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');
  
      if (gridItem) gridItem.setAttribute('href', variantUrl);
    }
  
    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.amz-gp__color-img--${id}`).classList.remove('is-active');
    }
  
    /* Setup event listeners */
    _bindEvents() {
      this.buttons.forEach(button => {
        const id = button.dataset.button;
  
        button.on('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id);
        });
      });
  
      // Display active hotspot block on theme editor select
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }
  
    /* Toggle sidebar content */
    _showContent(id) {
      // Hide all hotspotBlock
      // Show the hotspotBlock with the id
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      });
    }
  
    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // Ensure we are utilizing the right version of QuickShop based off of theme
        if (typeof apx.QuickShop === 'function') {
          new apx.QuickShop(this.blockContainer);
        } else if (typeof apx.initQuickShop === 'function') {
          apx.initQuickShop();
        }
  
        if (typeof apx.QuickAdd === 'function') {
          new apx.QuickAdd(this.blockContainer);
        }
      }
    }
  }
  
  customElements.define('hot-spots', HotSpots);
  
  /*============================================================================
    ImageCompare
  ==============================================================================*/
  
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');
  
      this.calculateSizes();
  
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);
  
      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);
  
      window.on('resize', apx.utils.debounce(250, () => { this.calculateSizes(true)}));
  
      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }
  
    calculateSizes(hasResized = false) {
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.elWidth = this.el.offsetWidth;
  
      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
  
      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }
  
      if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
    }
  
    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }
  
      if (e.target === this.button) {
        this.active = true;
      }
    }
  
    dragEnd(e) {
      this.initialX = this.currentX;
  
      this.active = false;
    }
  
    drag(e) {
      if (this.active) {
  
        e.preventDefault();
  
        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }
  
        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }
  
    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth/2) + xPos;
  
      const boundaryPadding = 50;
      const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth/2 - this.buttonOffset;
  
      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }
  
      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }
  
  customElements.define('image-compare', ImageCompare);
  


  apx.Blog = (function() {

  

    function Blog(container) {

      this.tagFilters();

    }

  

    Blog.prototype = Object.assign({}, Blog.prototype, {

      tagFilters: function() {

        var filterBy = document.getElementById('BlogTagFilter');

  

        if (!filterBy) {

          return;

        }

  

        filterBy.addEventListener('change', function() {

          location.href = filterBy.value;

        });

      }

    });

  

    return Blog;

  })();

  
  apx.CollectionHeader = (function() {
    var hasLoadedBefore = false;
  
    function CollectionHeader(container) {
      this.namespace = '.collection-header';
  
      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        heroImageContainer.classList.remove('loading', 'amz-load--delayed');
        heroImageContainer.classList.add('loaded');
      } else if (apx.settings.overlayHeader) {
        apx.headerNav.disableOverlayHeader();
      }
  
      hasLoadedBefore = true;
    }
  
    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (apx.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  apx.CollectionSidebar = (function() {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
    };
  
    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }
  
    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        // Do not load when no sidebar exists
        if(!this.container) {
          return;
        }
  
        this.onUnload();
  
        drawerStyle = this.container.dataset.style === 'drawer';
        apx.FilterDrawer = new apx.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (apx.FilterDrawer) {
          if (!drawerStyle) {
            apx.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || apx.config.bpSmall) {
            apx.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (apx.FilterDrawer) {
          apx.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (apx.FilterDrawer) {
          apx.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  apx.Collection = (function() {
    var isAnimating = false;
  
    var selectors = {
      sortSelect: '#SortBy',
  
      colorSwatchImage: '.amz-gp__color-img',
      colorSwatch: '.color-swatch--with-image',
  
      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new apx.CollectionSidebar(container);
      this.context = container.getAttribute('data-context');
      this.ajaxRenderer = new apx.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });
  
      this.init();
    }
  
    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function() {
  
        /* Prevent extra JS from running for featured collection on a collection template */
        if (this.context && this.context === 'featured-collection') {
          this.colorSwatchHovering();
        } else {
          this.initSort();
          this.colorSwatchHovering();
          this.initFilters();
          this.initPriceRange();
          this.sidebar.init();
        }
      },
  
      initSort: function() {
        this.sortSelect = document.querySelector(selectors.sortSelect);
  
        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },
  
      getSortValue: function() {
        return this.sortSelect.value || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.sortSelect.getAttribute('data-default-sortby');
      },
  
      onSortChange: function() {
        this.queryParams = new URLSearchParams(window.location.search);
  
        this.queryParams.set('sort_by', this.getSortValue());
        this.queryParams.delete('page'); // Delete if it exists
  
        window.location.search = this.queryParams.toString();
      },
  
      colorSwatchHovering: function() {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }
  
        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', () => {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = this.container.querySelector('.amz-gp__color-img--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', () => {
            var id = swatch.dataset.variantId;
            this.container.querySelector('.amz-gp__color-img--' + id).classList.remove('is-active');
          });
        });
      },
  
      /*====================
        Collection filters
      ====================*/
      initFilters: function() {
        var tags = document.querySelectorAll(selectors.tags);
  
        if (!tags.length) {
          return;
        }
  
        this.bindBackButton();
  
        // Set mobile top value for filters if sticky header enabled
        if (apx.config.stickyHeader) {
          this.setFilterStickyPosition();
  
          window.on('resize', apx.utils.debounce(500, this.setFilterStickyPosition));
        }
  
        document.querySelectorAll(selectors.activeTags).forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });
  
        document.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('input', this.onFormSubmit.bind(this));
        });
      },
  
      initPriceRange: function() {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new apx.PriceRange(el, {
          // onChange passes in formData
          onChange: this.renderFromFormData.bind(this),
        }));
      },
  
      tagClick: function(evt) {
        var el = evt.currentTarget;
  
        if (apx.FilterDrawer) {
          apx.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
  
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        const parent = el.parentNode;
        const newUrl = new URL(el.href);
  
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },
  
      onFormSubmit: function(evt) {
        var el = evt.target;
  
        if (apx.FilterDrawer) {
          apx.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        const parent = el.closest('li');
        const formEl = el.closest('form');
        const formData = new FormData(formEl);
  
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },
  
      fetchOpenCollasibleFilters: function() {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },
  
      renderActiveTag: function(parent, el) {
        const textEl = parent.querySelector('.tag__text');
  
        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);
  
          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            document.querySelectorAll(selectors.activeTagList).forEach(list => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = textEl.innerText;
              newTag.appendChild(newTagLink);
  
              list.appendChild(newTag);
            });
          }
        }
      },
  
      renderFromFormData: function(formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },
  
      onReplaceAjaxContent: function(newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();
  
        openCollapsibleIds.forEach(selector => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });
  
        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }
  
        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
      },
  
      openCollapsible: function(el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }
  
        el.classList.add(classes.isOpen);
      },
  
      renderCollectionPage: function(searchParams, updateURLHash = true) {
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            apx.sections.reinit('collection-grid');
            this.updateScroll(false);
            this.initPriceRange();
            apx.reinitProductGridItem();
  
            document.dispatchEvent(new CustomEvent('collection:reloaded'));
  
            isAnimating = false;
          });
      },
  
      bindBackButton: function() {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function(state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },
  
      updateScroll: function(animate) {
        var scrollToElement = document.querySelector('[data-scroll-to]');
        var scrollTo = scrollToElement && scrollToElement.offsetTop;
  
        if (!apx.config.bpSmall) {
          scrollTo -= 15;
        }
  
        if (apx.config.stickyHeader) {
          var headerHeight = document.querySelector('.amz-hdr').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }
  
        if (animate) {
          window.scrollTo({top: scrollTo, behavior: 'smooth'});
        } else {
          window.scrollTo({top: scrollTo});
        }
      },
  
      setFilterStickyPosition: function() {
        var headerHeight = document.querySelector('.amz-hdr').offsetHeight;
        document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';
  
        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px';
        }
      },
  
      forceReload: function() {
        this.init();
      },
  
      startLoading: function() {
        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });
  
    return Collection;
  })();
  
  apx.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new apx.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new apx.Disclosure(currencyEl);
        }
  
        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function() {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }
  
        // Re-hook up collapsible box triggers
        apx.collapsibles.init(this.container);
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return FooterSection;
  })();
  
  apx.HeaderSection = (function() {
  
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
  
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          apx.sections.reinit('slideshow-section');
  
          // Set a timer to resize the header in case the logo changes size
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }
  
        this.initDrawers();
        this.initDisclosures();
        apx.headerNav.init();
        apx.announcementBar.init();
        this.hoverMenu();
      },
  
      hoverMenu: function() {
        const detailsEl = document.querySelectorAll('[data-apx-section="header"] details[data-hover="true"]');
  
        detailsEl.forEach((detail) => {
          const summary = detail.querySelector('summary');
          const summaryLink = summary.dataset.link;
  
          summary.addEventListener('click', e => {
            e.preventDefault();
            window.location.href = summaryLink;
          });
  
          // if detail has :focus-within
          detail.addEventListener('focusin', () => {
            if (!detail.hasAttribute('open')) {
  
              // close all other details
              detailsEl.forEach((detail) => {
                detail.removeAttribute('open');
                detail.setAttribute('aria-expanded', 'false');
              });
  
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
  
          detail.addEventListener('focusout', () => {
            if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
  
          detail.addEventListener('mouseover', () => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
  
          detail.addEventListener('mouseleave', () => {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        });
      },
  
      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new apx.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new apx.Disclosure(currencyEl);
        }
      },
  
      initDrawers: function() {
        apx.NavDrawer = new apx.Drawers('NavDrawer', 'nav');
        if (apx.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new apx.CartDrawer();
          }
        }
  
        apx.collapsibles.init(document.getElementById('NavDrawer'));
      },
  
      onUnload: function() {
        apx.NavDrawer.close();
        apx.announcementBar.unload();
  
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return HeaderSection;
  })();
  
  apx.Product = (function() {
    var videoObjects = {};
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
      lowInventory: 'inventory--low',
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };
  
    function Product(container) {
      this.container = container;
      container.apxProduct = this;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.modal;
  
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }
  
      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.amz-prod__form',
  
        media: '[data-product-media-type-model]',
        closeMedia: '.amz-prod__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',
  
        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',
  
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
  
        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
  
        availabilityContainer: '[data-amz-sa-holder]'
      };
  
      this.cacheElements();
  
      this.firstProductImage = this.cache.mainSlider.querySelector('img');
  
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }
  
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }
  
      this.init();
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.addIdToRecentlyViewed();
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
        }
      },
  
      cacheElements: function() {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
  
          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },
  
      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();
  
        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },
  
      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new apx.StoreAvailability(container);
        }
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = apx.Images.imageSize(currentImage);
        }
      },
  
      addIdToRecentlyViewed: function() {
        if (!apx.recentlyViewed || typeof apx.recentlyViewed.add !== 'function') {
          return;
        }

        apx.recentlyViewed.add({
          handle: this.container.getAttribute('data-product-handle'),
          url: this.container.getAttribute('data-product-url'),
          aspectRatio: this.container.getAttribute('data-aspect-ratio'),
          featuredImage: this.container.getAttribute('data-img-url')
        });
      },
  
      initVariants: function() {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
  
        if (!variantJson) {
          return;
        }
  
        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)
  
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled
        };
  
        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('updateSwatch', function(evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }
  
        this.variants = new apx.Variants(options);
  
        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
  
          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }
  
        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
  
        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
  
          // Update inventory on page load
          this.updateInventory({ detail: { variant: this.variants.currentVariant } });
  
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);
  
          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);
  
            if (variantType) {
              new apx.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }
  
        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },
  
      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new apx.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        new apx.AjaxProduct(this.cache.form);
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },
  
      updateCartButton: function(evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
  
        if (!cartBtn) return;
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = apx.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = apx.strings.unavailable;
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant) {
          // Regular price
          this.cache.price.innerHTML = apx.Currency.formatMoney(variant.price, apx.settings.moneyFormat);
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = apx.Currency.formatMoney(variant.compare_at_price, apx.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
  
            if (apx.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = apx.Currency.formatMoney(savings, apx.settings.moneyFormat);
            }
  
            this.cache.savePrice.classList.remove(classes.hidden);
            // data-save-static: label-only savings badge, keep the Liquid-rendered label
            if (!this.cache.savePrice.hasAttribute('data-save-static')) {
              this.cache.savePrice.innerHTML = apx.strings.savePrice.replace('[saved_amount]', savings);
            }
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = apx.Currency.formatMoney(variant.unit_price, apx.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = apx.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },
  
      imageSetArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;
  
        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;
  
        // Always start on index 0
        this.settings.currentSlideIndex = 0;
  
        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="'+set+'"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },
  
      updateImageSet: function(evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }
  
        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
  
        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }
  
        this.initProductSlider(variant);
      },
  
      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function(set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },
  
      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
  
      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.detail.variant;
  
        // Override to display in stock message for sold out variants with policy set to continue
        // Must be set to true in order to display in stock message for sold out variants
        const inStockForOOSAndContinueSelling = false;
  
        if (!variant) {
          // Variant is unavailable
          // So we want to hide both the inventory quantity + incoming transfer notice
          this.toggleInventoryQuantity('hidden', false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        // Inventory management is nil
        // So we want to hide the low inventory message but show an In stock status
        // And hide the incoming transfer notice
        if (!variant.inventory_management) {
          this.toggleInventoryQuantity('visible', false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          const variantInventoryObject = window.inventories[this.productId][variant.id];
  
          const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};
  
          this.toggleInventoryQuantity(undefined, quantity);
  
          if (inStockForOOSAndContinueSelling) {
            if (quantity <= 0 && policy === 'continue') {
              this.toggleInventoryQuantity('visible', false);
              this.toggleIncomingInventory(false);
              return;
            }
          }
  
          if ((incoming && !variant.available) || (quantity <= 0 && policy === 'continue')) {
            this.toggleIncomingInventory(true, next_incoming_date, policy);
          } else {
            this.toggleIncomingInventory(false);
          }
        }
      },
  
      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }
  
        this.storeAvailability.updateContent(variant.id);
      },
  
      toggleInventoryQuantity: function(state = undefined, quantity) {
        const productInventoryEl = this.container.querySelector(this.selectors.inventory);
        const inventorySalesPoint = productInventoryEl.closest('.sales-point');
  
        if (state && state === 'hidden') {
          // variant is unavailable
          // hide and return
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
  
          return;
        }
  
        let showLowInventoryMessage = false;
  
        // Check if we should show low inventory message
        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && parseInt(quantity) > 0) {
          showLowInventoryMessage = true;
        }
  
        if (parseInt(quantity) > 0 || (state && state === 'visible')) {
          if (showLowInventoryMessage) {
            productInventoryEl.parentNode.classList.add(classes.lowInventory);
            if (quantity > 1) {
              productInventoryEl.textContent = apx.strings.otherStockLabel.replace('[count]', quantity);
            } else {
              productInventoryEl.textContent = apx.strings.oneStockLabel.replace('[count]', quantity);
            }
          } else {
            productInventoryEl.parentNode.classList.remove(classes.lowInventory);
            productInventoryEl.textContent = apx.strings.inStockLabel;
          }
  
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.remove(classes.hidden);
          }
  
        } else {
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
        }
      },
  
      toggleIncomingInventory: function(showIncomingInventory, incomingInventoryDate, policy) {
  
        const incomingInventoryEl = this.container.querySelector(this.selectors.incomingInventory);
        const incomingInventoryIcon = incomingInventoryEl.querySelector('.icon-and-text');
  
        if (!incomingInventoryEl) return;
  
        const incomingInventoryBlockEnabled = incomingInventoryEl.dataset.enabled === 'true';
        const textEl = incomingInventoryEl.querySelector('.js-incoming-text');
  
        // If incoming inventory block is disabled, hide it
        if (!incomingInventoryBlockEnabled) {
          incomingInventoryEl.classList.add(classes.hidden);
          return;
        }
  
        if (showIncomingInventory) {
          if (incomingInventoryDate) {
            textEl.textContent = apx.strings.willBeInStockAfter.replace('[date]', incomingInventoryDate);
            incomingInventoryEl.classList.remove(classes.hidden);
          } else {
            textEl.textContent = apx.strings.waitingForStock;
            incomingInventoryEl.classList.remove(classes.hidden);
          }
  
          // When OOS and incoming inventory and continue selling disabled, update icon to low inventory
          if (incomingInventoryIcon) {
            if (policy !== 'continue') {
              incomingInventoryIcon.classList.add(classes.lowInventory);
            } else {
              incomingInventoryIcon.classList.remove(classes.lowInventory);
            }
          }
  
        } else {
          incomingInventoryEl.classList.add(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
  
        if (!productVideos.length) {
          return false;
        }
  
        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },
  
      initYoutubeVideo: function(div) {
        videoObjects[div.id] = new apx.YouTube(
          div.id,
          {
            videoId: div.dataset.videoId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },
  
      initVimeoVideo: function(div) {
        videoObjects[div.id] = new apx.VimeoPlayer(
          div.id,
          div.dataset.videoId,
          {
            videoParent: selectors.videoParent,
            autoplay: false,
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
          }
        )
      },
  
      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;
  
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }
  
        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;
  
        if (obj.options.style !== 'sound') {
          player.mute();
        }
  
        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change
  
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },
  
      _isFirstSlide: function(id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },
  
      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];
  
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },
  
      initMp4Video: function(div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };
  
        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
  
      stopVideos: function() {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },
  
      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },
  
      _getVideoDivId: function(video) {
        return video.id;
      },
  
      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Playing as expected
          })
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute('controls', '');
            player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new apx.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.apxSlider) {
            this.apxSlider.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },
  
      getThumbIndex: function(target) {
        return target.dataset.index;
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = apx.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
  
        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);
  
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        // Go to that variant image's slide
        if (this.apxSlider) {
          this.apxSlider.goToSlide(imageIndex);
        }
      },
  
      initProductSlider: function(variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }
  
        // Destroy slider in preparation of new initialization
        if (this.apxSlider && typeof this.apxSlider.destroy === 'function') {
          this.apxSlider.destroy();
        }
  
        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }
  
        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };
  
        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }
  
        this.apxSlider = new apx.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },
  
      onSliderInit: function(slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },
  
      onSlideChange: function(index) {
        if (!this.apxSlider) return;
  
        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');
  
        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
                        this.cache.mainSlider.querySelectorAll('.amz-fc-track .product-main-slide')[index] :
                        this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+index+'"]');
  
        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);
  
        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);
  
        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);
  
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },
  
      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }
  
        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },
  
      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.apxSlider.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }
  
        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.amz-prod__close-media').setAttribute('tabindex', 0);
        }
      },
  
      _slideIndex: function(el) {
        return el.getAttribute('data-index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        var initialized = false;
  
        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var finishBlocks = function() {
            this.cacheElements();
            this.formSetup();
            this.updateModalProductInventory();
  
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            apx.collapsibles.init(this.container);
  
            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.productId
              }
            }));
          }.bind(this);
  
          if (this.blocksHolder && this.blocksHolder.dataset.url) {
            var url = this.blocksHolder.dataset.url;
  
            fetch(url).then(function(response) {
              return response.text();
            }).then(function(html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var blocks = doc.querySelector(selectors.blocks);
  
              if (!blocks) {
                finishBlocks();
                return;
              }
  
              blocks.querySelectorAll('[id]').forEach(el => {
                var val = el.getAttribute('id');
                el.setAttribute('id', val + '-modal');
  
                var label = blocks.querySelector(`[for="${val}"]`);
                if (label) {
                  label.setAttribute('for', val + '-modal');
                }
  
                var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
                if (collapsibleTrigger) {
                  collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
                }
              });
  
              var form = blocks.querySelector(this.selectors.form);
              if (form) {
                var formId = form.getAttribute('id');
                blocks.querySelectorAll('[form]').forEach(el => {
                  el.setAttribute('form', formId);
                });
              }
  
              this.blocksHolder.innerHTML = '';
              this.blocksHolder.append(blocks);
              this.blocksHolder.classList.add('product-form-holder--loaded');
              finishBlocks();
            }.bind(this));
          } else {
            finishBlocks();
          }
  
          this.productSetup();
          this.videoSetup();
  
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function(evt) {
                if (evt.detail.productId === this.productId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }
  
        if (apx.refreshAOS) { apx.refreshAOS(true); }
  
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};
  
          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },
  
      closeModalProduct: function() {
        this.stopVideos();
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;
  
        apx.ProductMedia.init(modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        document.addEventListener(
          'shopify_xr_launch',
          function() {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },
  
      customMediaListners: function() {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function() {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });
  
        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              this.mediaLoaded(evt);
            }.bind(this));
  
            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },
  
      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });
  
        if (this.apxSlider) {
          this.apxSlider.setDraggable(false);
        }
      },
  
      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });
  
        if (this.apxSlider) {
          this.apxSlider.setDraggable(true);
        }
      },
  
      onUnload: function() {
        apx.ProductMedia.removeSectionModels(this.sectionId);
  
        if (this.apxSlider && typeof this.apxSlider.destroy === 'function') {
          this.apxSlider.destroy();
        }
      }
    });
  
    return Product;
  })();
  
  apx.RecentlyViewed = (function() {
    function RecentlyViewed(container) {
      if (!container) {
        return;
      }
  
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.amz-rv' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
      this.imageSizes = this.container.getAttribute('data-image-sizes');
      this.limit = parseInt(this.container.getAttribute('data-recent-count'), 10) || 4;
  
      apx.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };
  
    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function() {
        if (this.container.getAttribute('data-apx-rv-init') === 'true') {
          return;
        }
  
        this.container.setAttribute('data-apx-rv-init', 'true');
  
        if (Object.keys(apx.recentlyViewed.recent).length === 0 && apx.recentlyViewed.recent.constructor === Object) {
          this.container.classList.add('hide');
          return;
        }
  
        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');
  
        var promises = [];
        var handles = typeof apx.recentlyViewed.getOrderedHandles === 'function' ? apx.recentlyViewed.getOrderedHandles() : Object.keys(apx.recentlyViewed.recent);

        handles.forEach(function (handle) {
          if (handle !== 'undefined') {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));
  
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (apx.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(apx.recentlyViewed.productInfo[handle]);
          } else {
            fetch(((apx.routes && apx.routes.localeRoot) || '/') + 'products/' + handle + '.js').then(function(response) {
              return response.text();
            }).then(function(product) {
              resolve(product);
            }).catch(function() {
              resolve(null);
            });
          }
        });
      },
  
      parseProduct: function(product) {
        if (!product) {
          return null;
        }
  
        if (typeof product === 'string') {
          try {
            product = JSON.parse(product);
          } catch (e) {
            return null;
          }
        }
  
        if (!product || typeof product.handle === 'undefined') {
          return null;
        }
  
        return product;
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var limit = parseInt(this.container.getAttribute('data-recent-count'), 10) || this.limit;
  
        Object.keys(products).forEach(function (key) {
          var product = this.parseProduct(products[key]);
  
          if (!product) {
            return;
          }
  
          if (product.handle === this.handle) {
            return;
          }
  
          var recentProduct = apx.recentlyViewed.recent[product.handle] || {};
          var featuredImage = product.featured_image || recentProduct.featuredImage;
          const widths = [180, 360, 540, 720, 900];
  
          product.url = recentProduct.url || product.url;
          product.image_responsive_url = apx.Images.buildImagePath(featuredImage);
          product.image_responsive_urls = apx.Images.buildImagePath(featuredImage, widths);
          product.image_aspect_ratio = recentProduct.aspectRatio || product.image_aspect_ratio;
  
          var firstVariant = product.variants && product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
  
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
  
            product.unit_price = apx.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
  
          allProducts.unshift(product);
        }.bind(this));
  
        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }
  
        var productMarkup = apx.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf, this.imageSizes);
  
        this.outputContainer.innerHTML = productMarkup;
  
        if (window.AOS) {
          if (apx.refreshAOS) { apx.refreshAOS(true); }
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = this.parseProduct(products[i]);
  
          if (product) {
            apx.recentlyViewed.productInfo[product.handle] = product;
          }
        }
  
        if (apx.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(apx.recentlyViewed.productInfo));
        }
      },
  
      onUnload: function() {
        this.container.removeAttribute('data-apx-rv-init');
      }
    });
  
    return RecentlyViewed;
  })();
  
  apx.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };
  
    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      apx.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        if (this.container && (this.container.hasAttribute('data-amz-swiper-mode') || this.slideshow.hasAttribute('data-amz-swiper-mode'))) {
          return;
        }

        // Force the lightweight AMZ fallback slider when the section opts in.
        // This avoids blank sections when ApxSlider exists but does not initialize correctly.
        if (this.container && this.container.hasAttribute('data-amz-testimonials-fallback')) {
          return;
        }

        // If ApxSlider is not available,
        // we let the AMZ fallback slider handle testimonials instead.
        if (typeof window.ApxSlider === 'undefined') {
          return;
        }

        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.apxSlider = new apx.Slideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.apxSlider.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.apxSlider && typeof this.apxSlider.destroy === 'function') {
          this.apxSlider.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.apxSlider && typeof this.apxSlider.play === 'function') {
          this.apxSlider.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.apxSlider && typeof this.apxSlider.pause === 'function') {
          this.apxSlider.goToSlide(index);
          this.apxSlider.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.apxSlider && typeof this.apxSlider.play === 'function') {
          this.apxSlider.play();
        }
      }
    });
  
    return Testimonials;
  })();
  

  apx.isStorageSupported = function(type) {
    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  apx.recentlyViewed.safeParse = function(value, fallback) {
    if (!value) {
      return fallback;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  apx.recentlyViewed.normalizeOrder = function() {
    var cleanOrder = [];
    var recent = this.recent && typeof this.recent === 'object' && !Array.isArray(this.recent) ? this.recent : {};
    var order = Array.isArray(this.recentOrder) ? this.recentOrder : [];

    order.forEach(function(handle) {
      if (handle && handle !== 'undefined' && recent[handle] && cleanOrder.indexOf(handle) === -1) {
        cleanOrder.push(handle);
      }
    });

    Object.keys(recent).forEach(function(handle) {
      if (handle && handle !== 'undefined' && cleanOrder.indexOf(handle) === -1) {
        cleanOrder.push(handle);
      }
    });

    this.recent = recent;
    this.recentOrder = cleanOrder;
  };

  apx.recentlyViewed.load = function() {
    if (!apx.config.hasLocalStorage) {
      this.recent = {};
      this.recentOrder = [];
      return;
    }

    var storedRecent = this.safeParse(window.localStorage.getItem('theme-recent'), {});
    var storedOrder = this.safeParse(window.localStorage.getItem('theme-recent-order'), []);

    if (Array.isArray(storedRecent)) {
      var convertedRecent = {};
      var convertedOrder = [];

      storedRecent.forEach(function(item) {
        if (item && item.handle) {
          convertedRecent[item.handle] = {
            url: item.url,
            aspectRatio: item.aspectRatio,
            featuredImage: item.featuredImage,
            timestamp: item.timestamp
          };
          convertedOrder.push(item.handle);
        }
      });

      storedRecent = convertedRecent;
      storedOrder = storedOrder.length ? storedOrder : convertedOrder;
    }

    this.recent = storedRecent && typeof storedRecent === 'object' ? storedRecent : {};
    this.recentOrder = Array.isArray(storedOrder) ? storedOrder : [];
    this.normalizeOrder();
  };

  apx.recentlyViewed.save = function() {
    this.normalizeOrder();

    if (!apx.config.hasLocalStorage) {
      return;
    }

    try {
      window.localStorage.setItem('theme-recent', JSON.stringify(this.recent));
      window.localStorage.setItem('theme-recent-order', JSON.stringify(this.recentOrder));
    } catch (error) {}
  };

  apx.recentlyViewed.add = function(item) {
    if (!item || !item.handle || item.handle === 'undefined') {
      return;
    }

    this.normalizeOrder();

    var handle = item.handle;
    var previous = this.recent[handle] || {};

    this.recent[handle] = {
      url: item.url || previous.url || (((apx.routes && apx.routes.localeRoot) || '/') + 'products/' + handle),
      aspectRatio: item.aspectRatio || previous.aspectRatio,
      featuredImage: item.featuredImage || previous.featuredImage,
      timestamp: Date.now()
    };

    this.recentOrder = this.recentOrder.filter(function(savedHandle) {
      return savedHandle !== handle && savedHandle && savedHandle !== 'undefined';
    });

    this.recentOrder.push(handle);

    while (this.recentOrder.length > 50) {
      delete this.recent[this.recentOrder.shift()];
    }

    this.save();
  };

  apx.recentlyViewed.getOrderedHandles = function() {
    this.normalizeOrder();
    return this.recentOrder.slice();
  };

  apx.recentlyViewed.trackCurrentProduct = function(scope) {
    if (typeof this.add !== 'function') {
      return;
    }

    var parent = scope || document;
    var productEl = parent.querySelector('[data-apx-section="product"][data-product-handle]');

    if (!productEl) {
      return;
    }

    this.add({
      handle: productEl.getAttribute('data-product-handle'),
      url: productEl.getAttribute('data-product-url'),
      aspectRatio: productEl.getAttribute('data-aspect-ratio'),
      featuredImage: productEl.getAttribute('data-img-url')
    });
  };


  apx.animationConfig = function() {
    var settings = window.apx && window.apx.settings && window.apx.settings.animations ? window.apx.settings.animations : {};
    return settings;
  };

  apx.animationsDisabled = function() {
    var settings = apx.animationConfig ? apx.animationConfig() : {};
    return settings.enabled === false || (document.body && document.body.getAttribute('data-amz-animations') === 'false');
  };

  apx.animationEnabled = function() {
    var settings = apx.animationConfig ? apx.animationConfig() : {};
    return settings.enabled !== false;
  };

  apx.animationValue = function(key, fallback) {
    var settings = apx.animationConfig ? apx.animationConfig() : {};
    var value = settings[key];
    if (typeof value === 'undefined' || value === null || value === '') return fallback;

    if (settings.performanceMode === 'maximum') {
      var numberValue = parseInt(value, 10);
      if (key === 'drawerOpenDelay') return 0;
      if (key === 'drawerOpenDuration' && numberValue > 360) return 360;
      if (key === 'drawerCloseDuration' && numberValue > 280) return 280;
      if (key === 'sliderSpeed' && numberValue > 420) return 420;
      if (key === 'sectionDuration' && numberValue > 320) return 320;
      if (key === 'rewardBarDuration' && numberValue > 360) return 360;
    }

    return value;
  };

  apx.drawerAnimationTime = function(type) {
    var key = type === 'close' ? 'drawerCloseDuration' : 'drawerOpenDuration';
    var delay = type === 'open' ? parseInt(apx.animationValue('drawerOpenDelay', 0), 10) || 0 : 0;
    var duration = parseInt(apx.animationValue(key, type === 'close' ? 330 : 450), 10) || 0;
    if (!apx.animationEnabled || !apx.animationEnabled()) return 30;
    return Math.max(90, duration + delay + 70);
  };

  apx.refreshAOS = (function() {
    var timer = null;
    return function(hard) {
      if (!window.AOS || (apx.animationsDisabled && apx.animationsDisabled())) return;
      if (timer) return;
      timer = window.setTimeout(function() {
        timer = null;
        if (!window.AOS) return;
        if (hard && typeof AOS.refreshHard === 'function') AOS.refreshHard();
        else if (typeof AOS.refresh === 'function') AOS.refresh();
      }, 120);
    };
  })();

  apx.isCollectionMobilePerformancePage = function() {
    return document.body && document.body.classList.contains('template-collection') && window.matchMedia('(max-width: 768px)').matches;
  };

  apx.prepareCollectionMobilePerformance = function(scope) {
    if (!apx.isCollectionMobilePerformancePage()) {
      return false;
    }

    var root = scope || document;
    document.documentElement.classList.add('amz-mobile-collection-performance');
    root.querySelectorAll('[data-aos]').forEach(function(el) {
      if (!el.getAttribute('data-amz-aos-original')) {
        el.setAttribute('data-amz-aos-original', el.getAttribute('data-aos') || '');
      }
      el.removeAttribute('data-aos');
      el.classList.add('aos-init');
      el.classList.add('aos-animate');
    });

    return true;
  };

  apx.reinitProductGridItem = function(scope) {
    var mobileCollectionMode = apx.prepareCollectionMobilePerformance(scope || document);

    if (window.AOS && !mobileCollectionMode) {
      if (apx.refreshAOS) { apx.refreshAOS(true); }
    }

    if (!document.documentElement.classList.contains('modal-open')) {
      apx.initQuickShop();
    }

    apx.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  apx.config.hasSessionStorage = apx.isStorageSupported('session');
  apx.config.hasLocalStorage = apx.isStorageSupported('local');
  if (apx.prepareCollectionMobilePerformance) {
    apx.prepareCollectionMobilePerformance(document);
  }

  if (window.AOS && !(apx.animationsDisabled && apx.animationsDisabled())) {
    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: parseInt(apx.animationValue ? apx.animationValue('sectionOffset', 60) : 60, 10) || 60,
      duration: parseInt(apx.animationValue ? apx.animationValue('sectionDuration', 420) : 420, 10) || 420,
      delay: parseInt(apx.animationValue ? apx.animationValue('sectionDelay', 0) : 0, 10) || 0,
      startEvent: 'load',
      disableMutationObserver: true,
      disable: function() {
        return (apx.animationsDisabled && apx.animationsDisabled()) || (apx.isCollectionMobilePerformancePage ? apx.isCollectionMobilePerformancePage() : false);
      }
    });
  } else {
    document.documentElement.classList.add('amz-disable-animations');
    document.querySelectorAll('[data-aos]').forEach(function(el) {
      el.classList.add('aos-init');
      el.classList.add('aos-animate');
      el.removeAttribute('data-aos');
    });
  }

  window.addEventListener('load', function() {
    setTimeout(function() {
      var imgs = document.querySelectorAll('.amz-img-el');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.opacity = '1';
        imgs[i].style.animation = 'none';
      }
    }, 1200);
  });

  apx.recentlyViewed.load();

  apx.recentlyViewed.productInfo = apx.config.hasSessionStorage ? apx.recentlyViewed.safeParse(sessionStorage['recent-products'], {}) : {};

  // Trigger events when going between breakpoints
  apx.config.bpSmall = matchMedia(apx.config.mediaQuerySmall).matches;
  matchMedia(apx.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      apx.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      apx.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  apx.initGlobals = function() {
    apx.collapsibles.init();
    apx.videoModal();
  }

  DOMready(function(){
    apx.recentlyViewed.trackCurrentProduct();

    apx.sections = new apx.Sections();

    apx.sections.register('slideshow-section', apx.SlideshowSection);
    apx.sections.register('header', apx.HeaderSection);
    apx.sections.register('product', apx.Product);
    apx.sections.register('blog', apx.Blog);
    apx.sections.register('password-header', apx.PasswordHeader);
    apx.sections.register('photoswipe', apx.Photoswipe);
    apx.sections.register('background-image', apx.BackgroundImage);
    apx.sections.register('testimonials', apx.Testimonials);
    apx.sections.register('video-section', apx.VideoSection);
    apx.sections.register('map', apx.Maps);
    apx.sections.register('footer-section', apx.FooterSection);
    apx.sections.register('amz-sa', apx.StoreAvailability);
    apx.sections.register('amz-rv', apx.RecentlyViewed);
    apx.sections.register('newsletter-popup', apx.NewsletterPopup);
    apx.sections.register('collection-header', apx.CollectionHeader);
    apx.sections.register('collection-grid', apx.Collection);

    apx.initGlobals();
    apx.initQuickShop();
    apx.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new apx.CartForm(cartPageForm);
      }
    }

    if (apx.settings.isCustomerTemplate) {
      apx.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('apx:ready'));
  });

})();

 (function() {
    if (!document.body || !document.body.classList.contains('template-product')) {
      return;
    }

    var sizeWords = [
      'size',
      'taille',
      'talla',
      'tamaño',
      'tamano',
      'größe',
      'grösse',
      'grosse',
      'taglia',
      'maat',
      'rozmiar',
      'tamanho',
      'beden',
      'storlek',
      'størrelse',
      'storrels',
      'koko',
      'velikost',
      'mărime',
      'marime',
      'størrelse',
      'størrelse',
      'størrelse',
      'størrelse'
    ];

    var sizeValues = [
      'xxs',
      'xs',
      's',
      'm',
      'l',
      'xl',
      'xxl',
      '2xl',
      '3xl',
      '4xl',
      '5xl',
      '6xl',
      'small',
      'medium',
      'large',
      'extra small',
      'extra large'
    ];

    function normalize(text) {
      return String(text || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function labelText(label) {
      if (!label) {
        return '';
      }

      var clone = label.cloneNode(true);
      var holder = clone.querySelector('.amz-kiwi-size-chart-holder');

      if (holder) {
        holder.remove();
      }

      return normalize(clone.textContent);
    }

    function hasSizeLabelText(wrapper) {
      var label = wrapper.querySelector('.variant__label');
      var text = labelText(label);

      for (var i = 0; i < sizeWords.length; i += 1) {
        if (text === normalize(sizeWords[i]) || text.indexOf(normalize(sizeWords[i])) === 0) {
          return true;
        }
      }

      var fieldset = wrapper.querySelector('fieldset');
      var name = normalize(fieldset ? fieldset.getAttribute('name') : '');
      var handle = normalize(fieldset ? fieldset.getAttribute('data-handle') : '');

      for (var j = 0; j < sizeWords.length; j += 1) {
        var word = normalize(sizeWords[j]);

        if (name === word || handle === word) {
          return true;
        }
      }

      return false;
    }

    function hasSizeOptionValues(wrapper) {
      var inputs = wrapper.querySelectorAll('input[type="radio"], option');
      var matches = 0;

      for (var i = 0; i < inputs.length; i += 1) {
        var value = normalize(inputs[i].value || inputs[i].textContent);

        for (var j = 0; j < sizeValues.length; j += 1) {
          if (value === normalize(sizeValues[j])) {
            matches += 1;
            break;
          }
        }
      }

      return matches >= 2;
    }

    function getSizeLabel() {
      var wrappers = document.querySelectorAll('.variant-wrapper');

      for (var i = 0; i < wrappers.length; i += 1) {
        if (hasSizeLabelText(wrappers[i])) {
          return wrappers[i].querySelector('.variant__label');
        }
      }

      for (var j = 0; j < wrappers.length; j += 1) {
        if (hasSizeOptionValues(wrappers[j])) {
          return wrappers[j].querySelector('.variant__label');
        }
      }

      return null;
    }

    function moveKiwiButton() {
      var kiwiChart = document.querySelector('.ks-chart-container, .sizing-chart-container');

      if (!kiwiChart) {
        return false;
      }

      var sizeLabel = getSizeLabel();

      if (!sizeLabel) {
        return false;
      }

      var holder = sizeLabel.querySelector('.amz-kiwi-size-chart-holder');

      if (!holder) {
        holder = document.createElement('span');
        holder.className = 'amz-kiwi-size-chart-holder';
        sizeLabel.appendChild(holder);
      }

      if (!holder.contains(kiwiChart)) {
        var oldParent = kiwiChart.parentElement;
        holder.appendChild(kiwiChart);

        if (oldParent && oldParent.children.length === 0) {
          oldParent.classList.add('amz-kiwi-original-empty');
        }

        var oldBlock = oldParent ? oldParent.closest('.product-block') : null;

        if (oldBlock && oldBlock.children.length === 0) {
          oldBlock.classList.add('amz-kiwi-original-empty');
        }
      }

      return true;
    }

    var observer;
    var observerTimer;

    function stopObserver() {
      if (observer) {
        observer.disconnect();
      }
      window.clearTimeout(observerTimer);
    }

    function watchForChart(duration) {
      if (!observer) {
        return;
      }
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(stopObserver, duration);
    }

    var attempts = 0;
    var timer = window.setInterval(function() {
      attempts += 1;

      if (moveKiwiButton() || attempts >= 60) {
        window.clearInterval(timer);
        stopObserver();
      }
    }, 250);

    document.addEventListener('DOMContentLoaded', moveKiwiButton);
    window.addEventListener('load', moveKiwiButton);
    document.addEventListener('shopify:section:load', function() {
      watchForChart(5000);
      moveKiwiButton();
    });
    document.addEventListener('variant:change', function() {
      watchForChart(5000);
      window.setTimeout(moveKiwiButton, 100);
    });
    document.addEventListener('product:variant-change', function() {
      watchForChart(5000);
      window.setTimeout(moveKiwiButton, 100);
    });

    observer = new MutationObserver(function() {
      if (moveKiwiButton()) {
        stopObserver();
      }
    });
    watchForChart(15000);
  })();

    (function(){
      var W = window;
      if (!W.AMZStockProgress) {
        W.AMZStockProgress = (function(){
          function getSeed(){
            try{
              var k = 'amz_sp_seed_v1';
              var v = sessionStorage.getItem(k);
              if (!v){
                v = String(Math.floor(Math.random()*2147483647));
                sessionStorage.setItem(k, v);
              }
              return v;
            }catch(e){
              return String(Math.floor(Math.random()*2147483647));
            }
          }
          function hashStr(s){
            var h = 2166136261;
            for (var i=0;i<s.length;i++){
              h ^= s.charCodeAt(i);
              h += (h<<1) + (h<<4) + (h<<7) + (h<<8) + (h<<24);
            }
            return h >>> 0;
          }
          function clamp(n, a, b){ return Math.min(b, Math.max(a, n)); }
          function parseNum(v, d){
            var n = parseFloat(v);
            return isNaN(n) ? d : n;
          }
          function hexToRgb(hex){
            if (!hex) return null;
            hex = String(hex).trim();
            if (!hex) return null;
            if (hex[0] === '#') hex = hex.slice(1);
            if (hex.length === 3){
              hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
            }
            if (hex.length !== 6) return null;
            var n = parseInt(hex, 16);
            if (isNaN(n)) return null;
            return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
          }
          function mixRgb(a, b, t){
            t = clamp(t, 0, 1);
            var r = Math.round(a.r + (b.r - a.r) * t);
            var g = Math.round(a.g + (b.g - a.g) * t);
            var bl = Math.round(a.b + (b.b - a.b) * t);
            return 'rgb(' + r + ',' + g + ',' + bl + ')';
          }
          function getDotColor(el, severity){
            var dyn = el.getAttribute('data-amz-sp-dotdyn') === '1';
            if (!dyn) return null;
            var style = (el.getAttribute('data-amz-sp-fillstyle') || 'gradient').toLowerCase();
            if (style === 'solid'){
              var solid = el.getAttribute('data-amz-sp-solid') || '';
              solid = String(solid).trim();
              return solid || null;
            }
            var g1 = hexToRgb(el.getAttribute('data-amz-sp-g1'));
            var g2 = hexToRgb(el.getAttribute('data-amz-sp-g2'));
            var g3 = hexToRgb(el.getAttribute('data-amz-sp-g3'));
            if (!g1 || !g2 || !g3) return null;
            var mid = parseNum(el.getAttribute('data-amz-sp-mid'), 60);
            mid = clamp(mid, 1, 99);
            severity = clamp(severity, 0, 100);
            if (severity <= mid){
              return mixRgb(g1, g2, severity / mid);
            }
            return mixRgb(g2, g3, (severity - mid) / (100 - mid));
          }
          function clearDotDyn(el){
            try{ el.style.removeProperty('--amz-sp-dot-dyn'); }catch(e){}
          }
          function setDotDyn(el, color){
            if (!color) { clearDotDyn(el); return; }
            try{ el.style.setProperty('--amz-sp-dot-dyn', color); }catch(e){}
          }
          function getVariantId(form){
            if (!form) return null;
            var idInput = form.querySelector('[name="id"]');
            if (idInput && idInput.value) return parseInt(idInput.value, 10);
            return null;
          }
          function findForm(el){
            if (!el) return null;
            var formId = el.getAttribute('data-amz-sp-form');
            var section = el.closest('.product-section') || el.closest('[data-section-id]') || null;
            if (section && formId){
              var forms = section.querySelectorAll('form');
              for (var i=0;i<forms.length;i++){
                if (forms[i].id === formId) return forms[i];
              }
            }
            if (section){
              var scopedForm = section.querySelector('form');
              if (scopedForm) return scopedForm;
            }
            return formId ? document.getElementById(formId) : null;
          }
          function buildVariantMap(el){
            var node = el.querySelector('[data-amz-sp-variants]');
            if (!node) return {};
            var txt = (node.textContent || '').trim();
            if (!txt) return {};
            try{
              var arr = JSON.parse(txt);
              var map = {};
              for (var i=0;i<arr.length;i++){
                map[arr[i].id] = arr[i];
              }
              return map;
            }catch(e){
              return {};
            }
          }
          function computeCount(el, variantId, min, max, reroll){
            var range = Math.max(0, (max - min) + 1);
            if (!range) return min;
            if (reroll) {
              return min + Math.floor(Math.random()*range);
            }
            var seed = getSeed();
            var blockKey = el.getAttribute('data-amz-sp-key') || el.id || '';
            var h = hashStr(seed + '|' + variantId + '|' + blockKey);
            return min + (h % range);
          }
          function computeFillPercent(count, min, max, exp, cap){
            cap = clamp(cap, 0, 100);
            if (max <= min) return cap;
            var norm = (max - count) / (max - min);
            norm = clamp(norm, 0, 1);
            var eased = Math.pow(norm, exp);
            return clamp(eased * cap, 0, cap);
          }
          function computeDynamicStepFill(count, min, startFill, stepFill, floorFill){
            startFill = clamp(startFill, 0, 100);
            stepFill = Math.max(0, parseNum(stepFill, 5));
            floorFill = clamp(floorFill, 0, 100);
            if (floorFill > startFill) floorFill = startFill;
            var stepsFromMin = Math.max(0, Math.round(count - min));
            return clamp(startFill - (stepsFromMin * stepFill), floorFill, startFill);
          }
          function normalizeValue(value){
            return String(value == null ? '' : value).toLowerCase().replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
          }
          function parseValueList(raw){
            var parts = String(raw || '').split(/[\n,;|]+/);
            var map = {};
            for (var i=0;i<parts.length;i++){
              var key = normalizeValue(parts[i]);
              if (key) map[key] = true;
            }
            return map;
          }
          function getSizeGroupConfig(el){
            if (el.__amzSizeGroupConfig) return el.__amzSizeGroupConfig;
            var cfg = {
              enabled: el.getAttribute('data-amz-sp-sizegroups') === '1',
              smallValues: parseValueList(el.getAttribute('data-amz-sp-size-small-values')),
              smallMin: parseInt(el.getAttribute('data-amz-sp-size-small-min') || '2', 10),
              smallMax: parseInt(el.getAttribute('data-amz-sp-size-small-max') || '3', 10),
              smallFillMode: (el.getAttribute('data-amz-sp-size-small-fill-mode') || 'static').toLowerCase(),
              smallFill: parseNum(el.getAttribute('data-amz-sp-size-small-fill'), 95),
              smallFillStep: parseNum(el.getAttribute('data-amz-sp-size-small-fill-step'), 5),
              smallFillFloor: parseNum(el.getAttribute('data-amz-sp-size-small-fill-floor'), 5),
              largeValues: parseValueList(el.getAttribute('data-amz-sp-size-large-values')),
              largeMin: parseInt(el.getAttribute('data-amz-sp-size-large-min') || '1', 10),
              largeMax: parseInt(el.getAttribute('data-amz-sp-size-large-max') || '1', 10),
              largeFillMode: (el.getAttribute('data-amz-sp-size-large-fill-mode') || 'static').toLowerCase(),
              largeFill: parseNum(el.getAttribute('data-amz-sp-size-large-fill'), 95),
              largeFillStep: parseNum(el.getAttribute('data-amz-sp-size-large-fill-step'), 5),
              largeFillFloor: parseNum(el.getAttribute('data-amz-sp-size-large-fill-floor'), 5)
            };
            if (isNaN(cfg.smallMin)) cfg.smallMin = 2;
            if (isNaN(cfg.smallMax)) cfg.smallMax = 3;
            if (cfg.smallMax < cfg.smallMin){ var s = cfg.smallMin; cfg.smallMin = cfg.smallMax; cfg.smallMax = s; }
            if (isNaN(cfg.largeMin)) cfg.largeMin = 1;
            if (isNaN(cfg.largeMax)) cfg.largeMax = 1;
            if (cfg.largeMax < cfg.largeMin){ var l = cfg.largeMin; cfg.largeMin = cfg.largeMax; cfg.largeMax = l; }
            cfg.smallFill = clamp(cfg.smallFill, 0, 100);
            cfg.smallFillStep = Math.max(0, parseNum(cfg.smallFillStep, 5));
            cfg.smallFillFloor = clamp(cfg.smallFillFloor, 0, 100);
            if (cfg.smallFillFloor > cfg.smallFill) cfg.smallFillFloor = cfg.smallFill;
            if (cfg.smallFillMode !== 'dynamic') cfg.smallFillMode = 'static';
            cfg.largeFill = clamp(cfg.largeFill, 0, 100);
            cfg.largeFillStep = Math.max(0, parseNum(cfg.largeFillStep, 5));
            cfg.largeFillFloor = clamp(cfg.largeFillFloor, 0, 100);
            if (cfg.largeFillFloor > cfg.largeFill) cfg.largeFillFloor = cfg.largeFill;
            if (cfg.largeFillMode !== 'dynamic') cfg.largeFillMode = 'static';
            el.__amzSizeGroupConfig = cfg;
            return cfg;
          }
          function getVariantCandidates(variant){
            var values = [];
            if (!variant) return values;
            if (variant.options && variant.options.length){
              for (var i=0;i<variant.options.length;i++){
                values.push(variant.options[i]);
              }
            }
            if (variant.option1) values.push(variant.option1);
            if (variant.option2) values.push(variant.option2);
            if (variant.option3) values.push(variant.option3);
            if (variant.title){
              values.push(variant.title);
              var titleParts = String(variant.title).split('/');
              for (var j=0;j<titleParts.length;j++){
                values.push(titleParts[j]);
              }
            }
            return values;
          }
          function getBehaviorOverride(el, variant){
            var cfg = getSizeGroupConfig(el);
            if (!cfg.enabled || !variant) return null;
            var candidates = getVariantCandidates(variant);
            for (var i=0;i<candidates.length;i++){
              var key = normalizeValue(candidates[i]);
              if (!key) continue;
              if (cfg.smallValues[key]){
                return {
                  min: cfg.smallMin,
                  max: cfg.smallMax,
                  minShow: cfg.smallMin,
                  fillMode: cfg.smallFillMode,
                  maxFill: cfg.smallFill,
                  fillStep: cfg.smallFillStep,
                  fillFloor: cfg.smallFillFloor
                };
              }
              if (cfg.largeValues[key]){
                return {
                  min: cfg.largeMin,
                  max: cfg.largeMax,
                  minShow: cfg.largeMin,
                  fillMode: cfg.largeFillMode,
                  maxFill: cfg.largeFill,
                  fillStep: cfg.largeFillStep,
                  fillFloor: cfg.largeFillFloor
                };
              }
            }
            return null;
          }
          function update(el){
            var min = parseInt(el.getAttribute('data-amz-sp-min') || '1', 10) || 1;
            var max = parseInt(el.getAttribute('data-amz-sp-max') || '15', 10) || 15;
            if (max < min){ var t=min; min=max; max=t; }
            var exp = parseNum(el.getAttribute('data-amz-sp-exp'), 1.4);
            var oosBehavior = (el.getAttribute('data-amz-sp-oos') || 'show').toLowerCase();
            var reroll = el.getAttribute('data-amz-sp-reroll') === '1';
            var minShow = parseInt(el.getAttribute('data-amz-sp-minshow') || '1', 10);
            if (isNaN(minShow)) minShow = 1;
            var maxFill = parseNum(el.getAttribute('data-amz-sp-maxfill'), 95);
            maxFill = clamp(maxFill, 0, 100);
            var form = findForm(el);

            var variantId = getVariantId(form);
            if (!variantId) return;

            var variantMap = el.__amzVariantMap || (el.__amzVariantMap = buildVariantMap(el));
            var v = variantMap[variantId];
            var behaviorOverride = getBehaviorOverride(el, v);
            var overrideFillMode = null;
            var overrideFillStep = 5;
            var overrideFillFloor = 0;
            if (behaviorOverride){
              min = behaviorOverride.min;
              max = behaviorOverride.max;
              minShow = behaviorOverride.minShow;
              maxFill = behaviorOverride.maxFill;
              overrideFillMode = behaviorOverride.fillMode || 'static';
              overrideFillStep = behaviorOverride.fillStep;
              overrideFillFloor = behaviorOverride.fillFloor;
              if (max < min){ var ts=min; min=max; max=ts; }
            }
            var beforeEl = el.querySelector('[data-amz-sp-before]');
            var afterEl = el.querySelector('[data-amz-sp-after]');
            var countEl = el.querySelector('[data-amz-sp-count]');
            var oosEl = el.querySelector('[data-amz-sp-oos-text]');
            var bar = el.querySelector('[data-amz-sp-bar]');
            var fill = el.querySelector('[data-amz-sp-fill]');

            if (v && v.available === false){
              if (oosBehavior === 'hide'){
                el.setAttribute('data-amz-sp-hidden','1');
                return;
              }
              el.setAttribute('data-amz-sp-hidden','0');
              el.setAttribute('data-amz-sp-state','oos');
              if (beforeEl) beforeEl.hidden = true;
              if (afterEl) afterEl.hidden = true;
              if (countEl) countEl.hidden = true;
              if (oosEl) oosEl.hidden = false;
              clearDotDyn(el);
              if (bar && fill && !bar.hasAttribute('hidden')){
                var oosFill = parseNum(el.getAttribute('data-amz-sp-oosfill'), 100);
                oosFill = clamp(oosFill, 0, 100);
                fill.style.width = oosFill.toFixed(2) + '%';
                bar.setAttribute('aria-valuenow', '0');
                bar.setAttribute('aria-valuemin', '0');
                bar.setAttribute('aria-valuemax', String(max));
              }
              return;
            }

            el.setAttribute('data-amz-sp-hidden','0');
            el.setAttribute('data-amz-sp-state','in');
            if (beforeEl) beforeEl.hidden = false;
            if (afterEl) afterEl.hidden = false;
            if (countEl) countEl.hidden = false;
            if (oosEl) oosEl.hidden = true;

            var count = computeCount(el, variantId, min, max, reroll);
            count = clamp(count, min, max);
            if (minShow > max) minShow = max;
            if (count < minShow) count = minShow;

            if (countEl) countEl.textContent = String(count);

            var minForBar = min;
            if (minShow > minForBar) minForBar = minShow;
            if (max < minForBar) minForBar = max;
            var pct;
            if (behaviorOverride){
              if (overrideFillMode === 'dynamic'){
                pct = computeDynamicStepFill(count, minForBar, maxFill, overrideFillStep, overrideFillFloor);
              } else {
                pct = clamp(maxFill, 0, 100);
              }
            } else {
              pct = computeFillPercent(count, minForBar, max, exp, maxFill);
            }

            var sev = maxFill > 0 ? (pct / maxFill) * 100 : 0;
            sev = clamp(sev, 0, 100);
            var dotColor = getDotColor(el, sev);
            if (dotColor) setDotDyn(el, dotColor); else clearDotDyn(el);

            if (bar && fill && !bar.hasAttribute('hidden')){
              fill.style.width = pct.toFixed(2) + '%';
              bar.setAttribute('aria-valuenow', String(count));
              bar.setAttribute('aria-valuemin', String(minForBar));
              bar.setAttribute('aria-valuemax', String(max));
            }
          }
          function attach(el){
            if (el.__amzSpAttached) return;
            el.__amzSpAttached = true;

            var form = findForm(el);

            var tick = null;
            function schedule(){
              if (tick) return;
              tick = requestAnimationFrame(function(){
                tick = null;
                update(el);
              });
            }

            schedule();

            if (form){
              form.addEventListener('change', schedule);
              form.addEventListener('input', schedule);
            }

            var section = el.closest('.product-section') || document;
            section.addEventListener('change', function(e){
              var t = e.target;
              if (!t) return;
              if (t.matches && (t.matches('[data-variant-input]') || t.matches('select') || t.matches('input'))){
                schedule();
              }
            }, true);

            document.addEventListener('variant:change', function(e){
              var d = e && e.detail ? e.detail : null;
              if (!d || !d.variant) { schedule(); return; }
              schedule();
            });
          }
          function initAll(root){
            var scope = root || document;
            var els = scope.querySelectorAll('[data-amz-stock-progress="1"]:not([data-amz-sp-inited])');
            for (var i=0;i<els.length;i++){
              els[i].setAttribute('data-amz-sp-inited','1');
              attach(els[i]);
            }
          }
          return { initAll: initAll };
        })();
      }
      W.AMZStockProgress.initAll(document);

      document.addEventListener('shopify:section:load', function(e){
        try{ W.AMZStockProgress.initAll(e.target); }catch(err){}
      });


      document.addEventListener('apx:quick-view:loaded', function(e){
        try{ W.AMZStockProgress.initAll(e && e.detail && e.detail.root ? e.detail.root : document); }catch(err){}
      });
      document.addEventListener('apx:quick-view:opened', function(e){
        try{ W.AMZStockProgress.initAll(e && e.detail && e.detail.root ? e.detail.root : document); }catch(err){}
      });
    })();

(function(){
  if(window.__amzProductGridHoverHelper) return;
  window.__amzProductGridHoverHelper = true;
  if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  function closest(el, selector){
    return el && el.closest ? el.closest(selector) : null;
  }

  function cardFromMask(mask){
    return closest(mask, '.amz-gp--hover-image');
  }

  function activate(mask){
    var card = cardFromMask(mask);
    if(!card || card.classList.contains('amz-swatch-hover-lock') || card.classList.contains('is-amz-swatch-image-changing')) return;
    card.classList.add('amz-gp--image-hover-active');
  }

  function deactivate(mask, relatedTarget){
    if(mask && relatedTarget && mask.contains(relatedTarget)) return;
    var card = cardFromMask(mask);
    if(card) card.classList.remove('amz-gp--image-hover-active');
  }

  document.addEventListener('mouseover', function(event){
    var mask = closest(event.target, '.amz-gp__img-mask');
    if(!mask) return;
    activate(mask);
  }, true);

  document.addEventListener('mouseout', function(event){
    var mask = closest(event.target, '.amz-gp__img-mask');
    if(!mask) return;
    deactivate(mask, event.relatedTarget);
  }, true);

  document.addEventListener('touchstart', function(event){
    var mask = closest(event.target, '.amz-gp__img-mask');
    if(!mask) return;
    var card = cardFromMask(mask);
    if(card) card.classList.remove('amz-gp--image-hover-active');
  }, { passive: true, capture: true });
})();

(function(){
  if (window.__amzProductGridHoverPointerFix) return;
  window.__amzProductGridHoverPointerFix = true;
  if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  function closest(el, selector){
    return el && el.closest ? el.closest(selector) : null;
  }

  function isLocked(card){
    return !card || card.classList.contains('amz-swatch-hover-lock') || card.classList.contains('is-amz-swatch-image-changing');
  }

  function setActive(card, active){
    if (!card) return;
    if (active && !isLocked(card)) {
      card.classList.add('amz-gp--image-hover-active');
    } else {
      card.classList.remove('amz-gp--image-hover-active');
    }
  }

  function pointerInsideMask(event, mask){
    if (!event || !mask || !mask.getBoundingClientRect) return false;
    var rect = mask.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
  }

  var lastCard = null;
  var lastEvent = null;
  var ticking = false;

  function update(){
    ticking = false;
    var event = lastEvent;
    if (!event) return;

    var card = closest(event.target, '.amz-gp--hover-image');
    if (lastCard && lastCard !== card) {
      setActive(lastCard, false);
    }

    if (!card || isLocked(card)) {
      if (card) setActive(card, false);
      lastCard = card || null;
      return;
    }

    var mask = card.querySelector('.amz-gp__img-mask');
    var active = pointerInsideMask(event, mask);
    setActive(card, active);
    lastCard = active ? card : null;
  }

  document.addEventListener('mousemove', function(event){
    lastEvent = event;
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }, true);

  document.addEventListener('mouseout', function(event){
    var card = closest(event.target, '.amz-gp--hover-image');
    if (!card) return;
    if (!event.relatedTarget || !card.contains(event.relatedTarget)) {
      setActive(card, false);
      if (lastCard === card) lastCard = null;
    }
  }, true);

  document.addEventListener('scroll', function(){
    if (lastCard) {
      setActive(lastCard, false);
      lastCard = null;
    }
  }, { passive: true, capture: true });
})();
